// // import React, { useState, useEffect, useMemo } from 'react';
// // import { useSelector } from 'react-redux';
// // import toast from 'react-hot-toast';
// // import configService from '../services/config';
// // import {
// //     Box,
// //     Stack,
// //     Paper,
// //     Typography,
// //     Button,
// //     IconButton,
// //     Chip,
// //     Table,
// //     TableBody,
// //     TableCell,
// //     TableContainer,
// //     TableHead,
// //     TableRow,
// //     TablePagination,
// //     Grid,
// //     FormControl,
// //     InputLabel,
// //     Select,
// //     MenuItem,
// //     TextField,
// //     InputAdornment,
// //     Dialog,
// //     DialogTitle,
// //     DialogContent,
// //     DialogActions,
// //     ToggleButton,
// //     ToggleButtonGroup,
// //     CircularProgress,
// //     useMediaQuery,
// //     Card,
// //     CardContent,
// // } from '@mui/material';
// // import { useTheme } from '@mui/material/styles';
// // import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// // import AccessTimeIcon from '@mui/icons-material/AccessTime';
// // import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// // import KeyboardIcon from '@mui/icons-material/Keyboard';
// // import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
// // import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
// // import AddIcon from '@mui/icons-material/Add';
// // import InboxIcon from '@mui/icons-material/Inbox';

// // const STATUS_CHIP = {
// //     Pending: { color: '#EA580C', bg: '#FFF7ED', border: '#FED7AA' },
// //     Approved: { color: '#16A34A', bg: '#F0FDF4', border: '#BBF7D0' },
// //     Rejected: { color: '#DC2626', bg: '#FEF2F2', border: '#FCA5A5' },
// // };

// // const ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50];

// // const getTodayString = () => {
// //     const today = new Date();
// //     const yyyy = today.getFullYear();
// //     const mm = String(today.getMonth() + 1).padStart(2, '0');
// //     const dd = String(today.getDate()).padStart(2, '0');
// //     return `${yyyy}-${mm}-${dd}`;
// // };

// // const getNextWeekString = () => {
// //     const futureDate = new Date();
// //     futureDate.setDate(futureDate.getDate() + 6);
// //     const yyyy = futureDate.getFullYear();
// //     const mm = String(futureDate.getMonth() + 1).padStart(2, '0');
// //     const dd = String(futureDate.getDate()).padStart(2, '0');
// //     return `${yyyy}-${mm}-${dd}`;
// // };

// // const convertTo24Hour = (timeStr) => {
// //     if (!timeStr || timeStr === '—') return '00:00:00';
// //     const [time, modifier] = timeStr.split(' ');
// //     let [hours, minutes] = time.split(':');

// //     if (hours === '12') {
// //         hours = '00';
// //     }
// //     if (modifier === 'PM') {
// //         hours = parseInt(hours, 10) + 12;
// //     }

// //     return `${String(hours).padStart(2, '0')}:${minutes}:00`;
// // };

// // export default function AttendanceRegularizationList() {
// //     const theme = useTheme();

// //     // Use breakpoints for switching between table and cards
// //     const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md')); // < 900px
// //     const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // < 600px

// //     // Exact breakpoints from reference CSS for responsive styling
// //     const isExtraLarge = useMediaQuery('(min-width:1600px)');
// //     const isLaptop = useMediaQuery('(max-width:1200px)');
// //     const isTabletLarge = useMediaQuery('(max-width:992px)');
// //     const isTablet = useMediaQuery('(max-width:768px)');
// //     const isSmallMobile = useMediaQuery('(max-width:420px)');
// //     const isLandscapeMobile = useMediaQuery('(max-height:500px) and (orientation:landscape)');

// //     const { company_id, userId } = useSelector((state) => state.globalVariables);
// //     const [regularizations, setRegularizations] = useState([]);
// //     const [loading, setLoading] = useState(true);

// //     const [page, setPage] = useState(0);
// //     const [rowsPerPage, setRowsPerPage] = useState(10);

// //     const [openModal, setOpenModal] = useState(false);
// //     const [category, setCategory] = useState('');
// //     const [timeType, setTimeType] = useState('');
// //     const [selectedDate, setSelectedDate] = useState(getTodayString());
// //     const [beginningTime, setBeginningTime] = useState('12:00 AM');
// //     const [endTime, setEndTime] = useState('12:00 AM');

// //     const [openPicker, setOpenPicker] = useState(false);
// //     const [activeField, setActiveField] = useState('beginning');
// //     const [pickerView, setPickerView] = useState('hours');
// //     const [selectedHour, setSelectedHour] = useState('12');
// //     const [selectedMinute, setSelectedMinute] = useState('00');
// //     const [ampm, setAmpm] = useState('AM');

// //     const fetchData = async () => {
// //         setLoading(true);
// //         try {
// //             const [regRes] = await Promise.all([
// //                 configService.getRegularizationList({ company_id, employee_id: userId }),
// //             ]);

// //             if (regRes?.status) {
// //                 setRegularizations(regRes.data || []);
// //             } else {
// //                 toast.error(regRes?.message || 'No regularization data found');
// //             }
// //         } catch (error) {
// //             console.error('Fetch error:', error);
// //             toast.error('Failed to load data. Check network or backend.');
// //         } finally {
// //             setLoading(false);
// //         }
// //     };

// //     useEffect(() => {
// //         fetchData();
// //     }, [company_id, userId]);

// //     useEffect(() => {
// //         setPage(0);
// //     }, [rowsPerPage, regularizations.length]);

// //     const handleSave = async () => {
// //         if (!category || !timeType || !selectedDate) {
// //             toast.error('Please fill all the required fields (Category, Time Type, and Date).');
// //             return;
// //         }

// //         const formattedBeginning = convertTo24Hour(beginningTime);
// //         const formattedEnd = convertTo24Hour(endTime);

// //         const formData = {
// //             company_id,
// //             employee_id: userId,
// //             customer_id: userId,
// //             category,
// //             time_type: timeType,
// //             entry_date: selectedDate,
// //             beginning: formattedBeginning,
// //             end_time: formattedEnd,
// //             remarks: timeType,
// //         };

// //         try {
// //             setLoading(true);
// //             const res = await configService.attendanceregularization(formData);

// //             if (res?.status === true || res?.data?.status === true || res?.status === 201) {
// //                 toast.success('Attendance Regularization saved successfully!');
// //                 handleCloseModal();
// //                 await fetchData();
// //             } else {
// //                 toast.error(res?.data?.message || res?.message || 'Failed to save.');
// //             }
// //         } catch (error) {
// //             console.error('Error saving attendance regularization:', error);
// //             toast.error(`Error: ${error?.response?.data?.message || error?.message || 'Server Error'}`);
// //         } finally {
// //             setLoading(false);
// //         }
// //     };

// //     const handleCloseModal = () => {
// //         setOpenModal(false);
// //         setCategory('');
// //         setTimeType('');
// //         setBeginningTime('12:00 AM');
// //         setEndTime('12:00 AM');
// //         setSelectedDate(getTodayString());
// //     };

// //     const handleOpenPicker = (field, currentTime) => {
// //         setActiveField(field);
// //         try {
// //             const [time, period] = currentTime.split(' ');
// //             const [hr, min] = time.split(':');
// //             setSelectedHour(hr || '12');
// //             setSelectedMinute(min || '00');
// //             setAmpm(period || 'AM');
// //         } catch (e) {
// //             setSelectedHour('12');
// //             setSelectedMinute('00');
// //             setAmpm('AM');
// //         }
// //         setPickerView('hours');
// //         setOpenPicker(true);
// //     };

// //     const handleClockSave = () => {
// //         const formattedTime = `${selectedHour}:${selectedMinute} ${ampm}`;
// //         if (activeField === 'beginning') {
// //             setBeginningTime(formattedTime);
// //         } else {
// //             setEndTime(formattedTime);
// //         }
// //         setOpenPicker(false);
// //     };

// //     const hoursData = [
// //         { n: '12', deg: 0 }, { n: '01', deg: 30 }, { n: '02', deg: 60 },
// //         { n: '03', deg: 90 }, { n: '04', deg: 120 }, { n: '05', deg: 150 },
// //         { n: '06', deg: 180 }, { n: '07', deg: 210 }, { n: '08', deg: 240 },
// //         { n: '09', deg: 270 }, { n: '10', deg: 300 }, { n: '11', deg: 330 },
// //     ];

// //     const minutesData = [
// //         { n: '00', deg: 0 }, { n: '05', deg: 30 }, { n: '10', deg: 60 },
// //         { n: '15', deg: 90 }, { n: '20', deg: 120 }, { n: '25', deg: 150 },
// //         { n: '30', deg: 180 }, { n: '35', deg: 210 }, { n: '40', deg: 240 },
// //         { n: '45', deg: 270 }, { n: '50', deg: 300 }, { n: '55', deg: 330 },
// //     ];

// //     const currentData = pickerView === 'hours' ? hoursData : minutesData;
// //     const currentSelection = pickerView === 'hours' ? selectedHour : selectedMinute;
// //     const currentRotation = currentData.find((d) => d.n === currentSelection)?.deg || 0;

// //     const fmtDate = (d) =>
// //         d ? new Date(d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : '—';

// //     const totalRows = regularizations.length;

// //     const paginatedRows = useMemo(() => {
// //         const start = page * rowsPerPage;
// //         return regularizations.slice(start, start + rowsPerPage);
// //     }, [regularizations, page, rowsPerPage]);

// //     const handleChangePage = (_e, newPage) => setPage(newPage);
// //     const handleChangeRowsPerPage = (e) => {
// //         setRowsPerPage(parseInt(e.target.value, 10));
// //         setPage(0);
// //     };

// //     // --- Dynamic responsive styles (matching reference CSS) ---
// //     const getResponsiveValues = () => {
// //         let rootPadding = '24px';
// //         let paperBorderRadius = '16px';
// //         let titleFontSize = '22px';
// //         let cellPadding = '12px 14px';
// //         let cellFontSize = '13.5px';
// //         let chipFontSize = '12px';
// //         let chipPadding = '4px 12px';
// //         let chipBorderRadius = '6px';
// //         let headerDirection = 'row';
// //         let buttonFullWidth = false;
// //         let modalFullScreen = false;
// //         let modalBorderRadius = '16px';
// //         let modalBodyPadding = '28px';
// //         let rootMaxWidth = 'none';
// //         let rootMargin = '0';

// //         if (isExtraLarge) {
// //             rootMaxWidth = '1400px';
// //             rootMargin = '0 auto';
// //             cellPadding = '16px 20px';
// //         }

// //         if (isTabletLarge) {
// //             headerDirection = 'column';
// //         }

// //         if (isTablet) {
// //             rootPadding = '16px';
// //             paperBorderRadius = '12px';
// //             cellPadding = '10px';
// //             cellFontSize = '0.8rem';
// //             chipFontSize = '0.75rem';
// //             chipPadding = '4px 10px';
// //             modalFullScreen = true;
// //             modalBorderRadius = '0';
// //             modalBodyPadding = '20px';
// //         }

// //         if (isMobile) {
// //             rootPadding = '14px';
// //             cellPadding = '8px 10px';
// //             cellFontSize = '0.8rem';
// //             chipFontSize = '0.65rem';
// //             chipPadding = '3px 8px';
// //             chipBorderRadius = '4px';
// //             titleFontSize = '1rem';
// //             modalBodyPadding = '14px';
// //             buttonFullWidth = true;
// //         }

// //         if (isSmallMobile) {
// //             rootPadding = '10px';
// //             cellPadding = '6px 8px';
// //             cellFontSize = '0.75rem';
// //             chipFontSize = '0.6rem';
// //             chipPadding = '2px 6px';
// //             titleFontSize = '0.95rem';
// //             modalBodyPadding = '12px';
// //         }

// //         if (isLandscapeMobile) {
// //             rootPadding = '8px';
// //             headerDirection = 'row';
// //             cellPadding = '6px 8px';
// //             cellFontSize = '0.7rem';
// //         }

// //         return {
// //             rootPadding,
// //             paperBorderRadius,
// //             titleFontSize,
// //             cellPadding,
// //             cellFontSize,
// //             chipFontSize,
// //             chipPadding,
// //             chipBorderRadius,
// //             headerDirection,
// //             buttonFullWidth,
// //             modalFullScreen,
// //             modalBorderRadius,
// //             modalBodyPadding,
// //             rootMaxWidth,
// //             rootMargin,
// //         };
// //     };

// //     const responsive = getResponsiveValues();

// //     const clockSize = isMobile ? 190 : 220;
// //     const clockRadius = isMobile ? 66 : 80;
// //     const clockCenter = clockSize / 2;

// //     if (loading && regularizations.length === 0) {
// //         return (
// //             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
// //                 <Stack spacing={2} alignItems="center">
// //                     <CircularProgress sx={{ color: '#6c5ce7' }} />
// //                     <Typography color="text.secondary">Loading...</Typography>
// //                 </Stack>
// //             </Box>
// //         );
// //     }

// //     // --- Render Cards for mobile/tablet ---
// //     const renderCards = () => (
// //         <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, py: 1 }}>
// //             {paginatedRows.map((r) => {
// //                 const status = r.status || 'Pending';
// //                 const sc = STATUS_CHIP[status] || STATUS_CHIP.Pending;
// //                 return (
// //                     <Card
// //                         key={r.id}
// //                         sx={{
// //                             bgcolor: '#ffffff',
// //                             border: '1px solid #e2e8f0',
// //                             boxShadow: 'none',
// //                             borderRadius: 2,
// //                             '&:hover': { bgcolor: '#f8fafc' },
// //                         }}
// //                     >
// //                         <CardContent sx={{ p: 2 }}>
// //                             <Stack spacing={1.5}>
// //                                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
// //                                     <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#0f172a' }}>
// //                                         {r.category}
// //                                     </Typography>
// //                                     <Chip
// //                                         label={status}
// //                                         size="small"
// //                                         sx={{
// //                                             bgcolor: sc.bg,
// //                                             color: sc.color,
// //                                             border: `1px solid ${sc.border}`,
// //                                             fontWeight: 600,
// //                                             fontSize: responsive.chipFontSize,
// //                                             padding: responsive.chipPadding,
// //                                             height: 'auto',
// //                                             borderRadius: responsive.chipBorderRadius,
// //                                         }}
// //                                     />
// //                                 </Box>
// //                                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'space-between' }}>
// //                                     <Typography variant="body2" sx={{ color: '#64748b' }}>
// //                                         <span style={{ fontWeight: 600, color: '#334155' }}>Time Type:</span> {r.time_type}
// //                                     </Typography>
// //                                     <Typography variant="body2" sx={{ color: '#64748b' }}>
// //                                         <span style={{ fontWeight: 600, color: '#334155' }}>Date:</span> {fmtDate(r.entry_date)}
// //                                     </Typography>
// //                                 </Box>
// //                                 <Typography variant="body2" sx={{ color: '#64748b' }}>
// //                                     <span style={{ fontWeight: 600, color: '#334155' }}>Remarks:</span> {r.remarks || '—'}
// //                                 </Typography>
// //                             </Stack>
// //                         </CardContent>
// //                     </Card>
// //                 );
// //             })}
// //         </Box>
// //     );

// //     // --- Render Table for larger screens ---
// //     const renderTable = () => (
// //         <TableContainer sx={{ flex: 1, overflowX: 'auto', overflowY: 'auto', maxWidth: '100%', width: '100%' }}>
// //             <Table
// //                 sx={{
// //                     width: '100%',
// //                     tableLayout: 'fixed',
// //                     borderCollapse: 'collapse',
// //                 }}
// //             >
// //                 <TableHead>
// //                     <TableRow sx={{ bgcolor: '#f8fafc' }}>
// //                         <TableCell
// //                             sx={{
// //                                 fontWeight: 700,
// //                                 fontSize: '11.5px',
// //                                 color: '#0f172a',
// //                                 textTransform: 'uppercase',
// //                                 letterSpacing: '0.05em',
// //                                 borderBottom: '1px solid #e2e8f0',
// //                                 whiteSpace: 'nowrap',
// //                                 padding: responsive.cellPadding,
// //                                 width: '20%',
// //                             }}
// //                         >
// //                             Work Type
// //                         </TableCell>
// //                         <TableCell
// //                             sx={{
// //                                 fontWeight: 700,
// //                                 fontSize: '11.5px',
// //                                 color: '#0f172a',
// //                                 textTransform: 'uppercase',
// //                                 letterSpacing: '0.05em',
// //                                 borderBottom: '1px solid #e2e8f0',
// //                                 whiteSpace: 'nowrap',
// //                                 padding: responsive.cellPadding,
// //                                 width: '20%',
// //                             }}
// //                         >
// //                             Time Type
// //                         </TableCell>
// //                         <TableCell
// //                             sx={{
// //                                 fontWeight: 700,
// //                                 fontSize: '11.5px',
// //                                 color: '#0f172a',
// //                                 textTransform: 'uppercase',
// //                                 letterSpacing: '0.05em',
// //                                 borderBottom: '1px solid #e2e8f0',
// //                                 whiteSpace: 'nowrap',
// //                                 padding: responsive.cellPadding,
// //                                 width: '20%',
// //                             }}
// //                         >
// //                             Date
// //                         </TableCell>
// //                         <TableCell
// //                             sx={{
// //                                 fontWeight: 700,
// //                                 fontSize: '11.5px',
// //                                 color: '#0f172a',
// //                                 textTransform: 'uppercase',
// //                                 letterSpacing: '0.05em',
// //                                 borderBottom: '1px solid #e2e8f0',
// //                                 whiteSpace: 'nowrap',
// //                                 padding: responsive.cellPadding,
// //                                 width: '25%',
// //                             }}
// //                         >
// //                             Remarks
// //                         </TableCell>
// //                         <TableCell
// //                             sx={{
// //                                 fontWeight: 700,
// //                                 fontSize: '11.5px',
// //                                 color: '#0f172a',
// //                                 textTransform: 'uppercase',
// //                                 letterSpacing: '0.05em',
// //                                 borderBottom: '1px solid #e2e8f0',
// //                                 whiteSpace: 'nowrap',
// //                                 padding: responsive.cellPadding,
// //                                 width: '15%',
// //                             }}
// //                         >
// //                             Status
// //                         </TableCell>
// //                     </TableRow>
// //                 </TableHead>
// //                 <TableBody>
// //                     {paginatedRows.map((r) => {
// //                         const status = r.status || 'Pending';
// //                         const sc = STATUS_CHIP[status] || STATUS_CHIP.Pending;
// //                         return (
// //                             <TableRow
// //                                 key={r.id}
// //                                 hover
// //                                 sx={{
// //                                     '&:last-child td': { border: 0 },
// //                                     '&:hover': { bgcolor: '#f8fafc' },
// //                                 }}
// //                             >
// //                                 <TableCell
// //                                     sx={{
// //                                         color: '#1e293b',
// //                                         fontWeight: 500,
// //                                         padding: responsive.cellPadding,
// //                                         fontSize: responsive.cellFontSize,
// //                                         overflow: 'hidden',
// //                                         textOverflow: 'ellipsis',
// //                                         whiteSpace: 'nowrap',
// //                                     }}
// //                                 >
// //                                     {r.category}
// //                                 </TableCell>
// //                                 <TableCell
// //                                     sx={{
// //                                         color: '#1e293b',
// //                                         padding: responsive.cellPadding,
// //                                         fontSize: responsive.cellFontSize,
// //                                         overflow: 'hidden',
// //                                         textOverflow: 'ellipsis',
// //                                         whiteSpace: 'nowrap',
// //                                     }}
// //                                 >
// //                                     {r.time_type}
// //                                 </TableCell>
// //                                 <TableCell
// //                                     sx={{
// //                                         color: '#64748b',
// //                                         padding: responsive.cellPadding,
// //                                         fontSize: responsive.cellFontSize,
// //                                         overflow: 'hidden',
// //                                         textOverflow: 'ellipsis',
// //                                         whiteSpace: 'nowrap',
// //                                     }}
// //                                 >
// //                                     {fmtDate(r.entry_date)}
// //                                 </TableCell>
// //                                 <TableCell
// //                                     sx={{
// //                                         color: '#64748b',
// //                                         padding: responsive.cellPadding,
// //                                         fontSize: responsive.cellFontSize,
// //                                         overflow: 'hidden',
// //                                         textOverflow: 'ellipsis',
// //                                         whiteSpace: 'nowrap',
// //                                     }}
// //                                 >
// //                                     {r.remarks}
// //                                 </TableCell>
// //                                 <TableCell sx={{ padding: responsive.cellPadding }}>
// //                                     <Chip
// //                                         label={status}
// //                                         size="small"
// //                                         sx={{
// //                                             bgcolor: sc.bg,
// //                                             color: sc.color,
// //                                             border: `1px solid ${sc.border}`,
// //                                             fontWeight: 600,
// //                                             fontSize: responsive.chipFontSize,
// //                                             padding: responsive.chipPadding,
// //                                             height: 'auto',
// //                                             borderRadius: responsive.chipBorderRadius,
// //                                         }}
// //                                     />
// //                                 </TableCell>
// //                             </TableRow>
// //                         );
// //                     })}
// //                 </TableBody>
// //             </Table>
// //         </TableContainer>
// //     );

// //     return (
// //         <Box
// //             sx={{
// //                 height: '100dvh',
// //                 width: '100%',
// //                 maxWidth: '100%',
// //                 overflow: 'hidden',
// //                 bgcolor: '#f8fafc',
// //                 display: 'flex',
// //                 flexDirection: 'column',
// //                 boxSizing: 'border-box',
// //                 p: responsive.rootPadding,
// //                 ...(responsive.rootMaxWidth !== 'none' && {
// //                     maxWidth: responsive.rootMaxWidth,
// //                     margin: responsive.rootMargin,
// //                 }),
// //             }}
// //         >
// //             {/* --- HEADER --- */}
// //             <Stack
// //                 direction={{ xs: 'column', sm: responsive.headerDirection === 'row' ? 'row' : 'column' }}
// //                 justifyContent="space-between"
// //                 alignItems={{ xs: 'stretch', sm: 'center' }}
// //                 spacing={2}
// //                 sx={{ flexShrink: 0, mb: 3 }}
// //             >
// //                 <Typography
// //                     variant="h5"
// //                     sx={{
// //                         fontWeight: 600,
// //                         color: '#1e293b',
// //                         fontSize: responsive.titleFontSize,
// //                     }}
// //                 >
// //                     Attendance Regularization
// //                 </Typography>
// //                 <Button
// //                     variant="contained"
// //                     startIcon={<AddIcon />}
// //                     onClick={() => setOpenModal(true)}
// //                     fullWidth={responsive.buttonFullWidth || isTabletLarge}
// //                     sx={{
// //                         bgcolor: '#6c5ce7',
// //                         color: '#fff',
// //                         textTransform: 'none',
// //                         fontWeight: 500,
// //                         borderRadius: 2,
// //                         px: 3,
// //                         py: 1,
// //                         boxShadow: '0 4px 6px -1px rgba(108, 92, 231, 0.2)',
// //                         '&:hover': { bgcolor: '#5b4bc4' },
// //                     }}
// //                 >
// //                     Apply Regularization
// //                 </Button>
// //             </Stack>

// //             {/* --- DATA TABLE / CARDS --- */}
// //             <Paper
// //                 elevation={0}
// //                 sx={{
// //                     borderRadius: responsive.paperBorderRadius,
// //                     border: '1px solid #e2e8f0',
// //                     overflow: 'hidden',
// //                     flex: 1,
// //                     display: 'flex',
// //                     flexDirection: 'column',
// //                     minHeight: 0,
// //                     maxWidth: '100%',
// //                 }}
// //             >
// //                 {totalRows === 0 ? (
// //                     <Stack alignItems="center" spacing={1.5} sx={{ py: 8, color: '#64748b' }}>
// //                         <InboxIcon sx={{ fontSize: 40, color: '#cbd5e1' }} />
// //                         <Typography>No regularization requests found.</Typography>
// //                     </Stack>
// //                 ) : (
// //                     <>
// //                         {isMobileOrTablet ? renderCards() : renderTable()}

// //                         <TablePagination
// //                             component="div"
// //                             count={totalRows}
// //                             page={page}
// //                             onPageChange={handleChangePage}
// //                             rowsPerPage={rowsPerPage}
// //                             onRowsPerPageChange={handleChangeRowsPerPage}
// //                             rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
// //                             labelRowsPerPage={isTablet ? 'Rows:' : 'Rows per page:'}
// //                             ActionsComponent={({ count, page: p, rowsPerPage: rpp, onPageChange }) => (
// //                                 <Stack direction="row" spacing={0.5} sx={{ ml: 1 }}>
// //                                     <IconButton
// //                                         size="small"
// //                                         onClick={(e) => onPageChange(e, p - 1)}
// //                                         disabled={p === 0}
// //                                     >
// //                                         <KeyboardArrowLeftIcon />
// //                                     </IconButton>
// //                                     <IconButton
// //                                         size="small"
// //                                         onClick={(e) => onPageChange(e, p + 1)}
// //                                         disabled={p >= Math.ceil(count / rpp) - 1}
// //                                     >
// //                                         <KeyboardArrowRightIcon />
// //                                     </IconButton>
// //                                 </Stack>
// //                             )}
// //                             sx={{
// //                                 borderTop: '1px solid #e2e8f0',
// //                                 flexShrink: 0,
// //                                 '& .MuiTablePagination-toolbar': {
// //                                     justifyContent: 'flex-end',
// //                                     flexWrap: 'wrap',
// //                                     px: isTablet ? 1 : 2,
// //                                 },
// //                                 '& .MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
// //                                     fontSize: isTablet ? '0.8rem' : '14px',
// //                                     color: '#64748b',
// //                                 },
// //                                 '& .MuiTablePagination-select': {
// //                                     fontSize: isTablet ? '0.8rem' : '14px',
// //                                 },
// //                             }}
// //                         />
// //                     </>
// //                 )}
// //             </Paper>

// //             {/* ── Modals (unchanged) ── */}
// //             {/* New Regularization Request Dialog */}
// //             <Dialog
// //                 open={openModal}
// //                 onClose={handleCloseModal}
// //                 fullScreen={responsive.modalFullScreen}
// //                 fullWidth
// //                 maxWidth="xs"
// //                 PaperProps={{
// //                     sx: {
// //                         borderRadius: responsive.modalBorderRadius,
// //                         border: '1px solid #e2e8f0',
// //                     },
// //                 }}
// //             >
// //                 <DialogTitle sx={{ fontWeight: 600, color: '#1e293b', pb: 1 }}>
// //                     New Regularization Request
// //                 </DialogTitle>
// //                 <DialogContent dividers sx={{ borderColor: '#e2e8f0', p: responsive.modalBodyPadding }}>
// //                     <Grid container spacing={2} sx={{ mt: 0.5 }}>
// //                         <Grid item xs={12}>
// //                             <FormControl fullWidth size="small">
// //                                 <InputLabel id="cat-label">Category</InputLabel>
// //                                 <Select
// //                                     labelId="cat-label"
// //                                     value={category}
// //                                     label="Category"
// //                                     onChange={(e) => setCategory(e.target.value)}
// //                                 >
// //                                     <MenuItem value="Working Times">Working Times</MenuItem>
// //                                     <MenuItem value="Break">Break</MenuItem>
// //                                     <MenuItem value="Overtime">Overtime</MenuItem>
// //                                 </Select>
// //                             </FormControl>
// //                         </Grid>

// //                         <Grid item xs={12}>
// //                             <FormControl fullWidth size="small">
// //                                 <InputLabel id="type-label">Time Type</InputLabel>
// //                                 <Select
// //                                     labelId="type-label"
// //                                     value={timeType}
// //                                     label="Time Type"
// //                                     onChange={(e) => setTimeType(e.target.value)}
// //                                 >
// //                                     <MenuItem value="Attendance Regularization">Attendance Regularization</MenuItem>
// //                                     <MenuItem value="On Duty">On Duty</MenuItem>
// //                                 </Select>
// //                             </FormControl>
// //                         </Grid>

// //                         <Grid item xs={12}>
// //                             <TextField
// //                                 label="Date"
// //                                 type="date"
// //                                 value={selectedDate}
// //                                 onChange={(e) => setSelectedDate(e.target.value)}
// //                                 fullWidth
// //                                 size="small"
// //                                 inputProps={{ min: getTodayString(), max: getNextWeekString() }}
// //                                 InputLabelProps={{ shrink: true }}
// //                                 InputProps={{
// //                                     endAdornment: (
// //                                         <InputAdornment position="end">
// //                                             <CalendarTodayIcon sx={{ color: '#6c5ce7', fontSize: '1.2rem' }} />
// //                                         </InputAdornment>
// //                                     ),
// //                                 }}
// //                             />
// //                         </Grid>

// //                         <Grid item xs={12}>
// //                             <TextField
// //                                 label="Beginning"
// //                                 value={beginningTime}
// //                                 onClick={() => handleOpenPicker('beginning', beginningTime)}
// //                                 fullWidth
// //                                 size="small"
// //                                 InputProps={{
// //                                     readOnly: true,
// //                                     endAdornment: (
// //                                         <InputAdornment position="end">
// //                                             <AccessTimeIcon sx={{ color: '#6c5ce7', cursor: 'pointer' }} />
// //                                         </InputAdornment>
// //                                     ),
// //                                 }}
// //                                 sx={{ cursor: 'pointer', '& input': { cursor: 'pointer' } }}
// //                             />
// //                         </Grid>

// //                         <Grid item xs={12}>
// //                             <TextField
// //                                 label="End"
// //                                 value={endTime}
// //                                 onClick={() => handleOpenPicker('end', endTime)}
// //                                 fullWidth
// //                                 size="small"
// //                                 InputProps={{
// //                                     readOnly: true,
// //                                     endAdornment: (
// //                                         <InputAdornment position="end">
// //                                             <AccessTimeIcon sx={{ color: '#6c5ce7', cursor: 'pointer' }} />
// //                                         </InputAdornment>
// //                                     ),
// //                                 }}
// //                                 sx={{ cursor: 'pointer', '& input': { cursor: 'pointer' } }}
// //                             />
// //                         </Grid>

// //                         <Grid item xs={12}>
// //                             <TextField
// //                                 label="Created By"
// //                                 value={userId || 'User'}
// //                                 fullWidth
// //                                 size="small"
// //                                 InputProps={{
// //                                     readOnly: true,
// //                                     startAdornment: (
// //                                         <InputAdornment position="start">
// //                                             <AccountCircleIcon sx={{ color: '#94a3b8', mr: 0.5 }} />
// //                                         </InputAdornment>
// //                                     ),
// //                                 }}
// //                                 sx={{ '& .MuiOutlinedInput-root': { bgcolor: '#f8fafc' } }}
// //                             />
// //                         </Grid>
// //                     </Grid>
// //                 </DialogContent>
// //                 <DialogActions sx={{ px: 3, py: 2 }}>
// //                     <Button
// //                         onClick={handleCloseModal}
// //                         sx={{ color: '#64748b', textTransform: 'none', '&:hover': { bgcolor: '#f1f5f9' } }}
// //                     >
// //                         Cancel
// //                     </Button>
// //                     <Button
// //                         variant="contained"
// //                         onClick={handleSave}
// //                         disabled={loading}
// //                         sx={{ bgcolor: '#6c5ce7', color: '#fff', px: 3, textTransform: 'none', '&:hover': { bgcolor: '#5b4bc4' } }}
// //                     >
// //                         {loading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Save'}
// //                     </Button>
// //                 </DialogActions>
// //             </Dialog>

// //             {/* Radial Clock Picker Dialog */}
// //             <Dialog
// //                 open={openPicker}
// //                 onClose={() => setOpenPicker(false)}
// //                 fullWidth
// //                 maxWidth="xs"
// //                 PaperProps={{
// //                     sx: {
// //                         borderRadius: 4,
// //                         p: isMobile ? 2 : 3,
// //                         border: '1px solid #e2e8f0',
// //                     },
// //                 }}
// //             >
// //                 <DialogContent sx={{ p: 0, overflow: 'visible' }}>
// //                     <Typography variant="body2" sx={{ color: '#64748b', mb: 2, fontWeight: 500 }}>
// //                         Select time
// //                     </Typography>

// //                     <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} sx={{ mb: 3, flexWrap: 'wrap' }}>
// //                         <Box
// //                             onClick={() => setPickerView('hours')}
// //                             sx={{
// //                                 bgcolor: pickerView === 'hours' ? 'rgba(108, 92, 231, 0.1)' : '#f8fafc',
// //                                 px: 2.5, py: 1.5, borderRadius: 2, cursor: 'pointer',
// //                                 border: pickerView === 'hours' ? '1px solid #6c5ce7' : '1px solid #cbd5e1',
// //                             }}
// //                         >
// //                             <Typography variant="h5" sx={{ color: pickerView === 'hours' ? '#6c5ce7' : '#1e293b', fontWeight: 500 }}>
// //                                 {selectedHour}
// //                             </Typography>
// //                         </Box>

// //                         <Typography variant="h5" sx={{ color: '#64748b' }}>:</Typography>

// //                         <Box
// //                             onClick={() => setPickerView('minutes')}
// //                             sx={{
// //                                 bgcolor: pickerView === 'minutes' ? 'rgba(108, 92, 231, 0.1)' : '#f8fafc',
// //                                 px: 2.5, py: 1.5, borderRadius: 2, cursor: 'pointer',
// //                                 border: pickerView === 'minutes' ? '1px solid #6c5ce7' : '1px solid #cbd5e1',
// //                             }}
// //                         >
// //                             <Typography variant="h5" sx={{ color: pickerView === 'minutes' ? '#6c5ce7' : '#1e293b', fontWeight: 500 }}>
// //                                 {selectedMinute}
// //                             </Typography>
// //                         </Box>

// //                         <ToggleButtonGroup
// //                             orientation="vertical"
// //                             value={ampm}
// //                             exclusive
// //                             onChange={(e, val) => val && setAmpm(val)}
// //                             sx={{
// //                                 border: '1px solid #cbd5e1',
// //                                 borderRadius: 2,
// //                                 ml: 1,
// //                                 bgcolor: '#f8fafc',
// //                                 '& .MuiToggleButton-root': {
// //                                     px: 1.5, py: 0.8, fontSize: '0.85rem', border: 'none', color: '#64748b',
// //                                     '&.Mui-selected': { bgcolor: 'rgba(108, 92, 231, 0.1)', color: '#6c5ce7', fontWeight: 'bold' },
// //                                 },
// //                             }}
// //                         >
// //                             <ToggleButton value="AM">AM</ToggleButton>
// //                             <ToggleButton value="PM" sx={{ borderTop: '1px solid #cbd5e1 !important' }}>PM</ToggleButton>
// //                         </ToggleButtonGroup>
// //                     </Stack>

// //                     <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
// //                         <Box
// //                             sx={{
// //                                 width: clockSize,
// //                                 height: clockSize,
// //                                 borderRadius: '50%',
// //                                 bgcolor: '#f8fafc',
// //                                 position: 'relative',
// //                                 border: '1px solid #cbd5e1',
// //                             }}
// //                         >
// //                             <Box
// //                                 sx={{
// //                                     width: 6,
// //                                     height: 6,
// //                                     bgcolor: '#6c5ce7',
// //                                     borderRadius: '50%',
// //                                     position: 'absolute',
// //                                     top: '50%',
// //                                     left: '50%',
// //                                     transform: 'translate(-50%, -50%)',
// //                                     zIndex: 3,
// //                                 }}
// //                             />
// //                             <Box
// //                                 sx={{
// //                                     position: 'absolute',
// //                                     width: 2,
// //                                     height: clockRadius - 4,
// //                                     bgcolor: '#6c5ce7',
// //                                     bottom: '50%',
// //                                     left: '50%',
// //                                     transformOrigin: 'bottom center',
// //                                     transform: `translateX(-50%) rotate(${currentRotation}deg)`,
// //                                     zIndex: 1,
// //                                 }}
// //                             />

// //                             {currentData.map((item) => {
// //                                 const angleRad = (item.deg - 90) * (Math.PI / 180);
// //                                 const x = clockCenter + clockRadius * Math.cos(angleRad);
// //                                 const y = clockCenter + clockRadius * Math.sin(angleRad);
// //                                 const isSelected = currentSelection === item.n;

// //                                 return (
// //                                     <Box
// //                                         key={item.n}
// //                                         onClick={() => {
// //                                             if (pickerView === 'hours') {
// //                                                 setSelectedHour(item.n);
// //                                                 setPickerView('minutes');
// //                                             } else {
// //                                                 setSelectedMinute(item.n);
// //                                             }
// //                                         }}
// //                                         sx={{
// //                                             position: 'absolute',
// //                                             left: x,
// //                                             top: y,
// //                                             transform: 'translate(-50%, -50%)',
// //                                             fontSize: '0.85rem',
// //                                             color: isSelected ? '#fff' : '#475569',
// //                                             cursor: 'pointer',
// //                                             zIndex: 2,
// //                                             width: 32,
// //                                             height: 32,
// //                                             display: 'flex',
// //                                             alignItems: 'center',
// //                                             justifyContent: 'center',
// //                                             borderRadius: '50%',
// //                                             transition: '0.1s',
// //                                             ...(isSelected && { bgcolor: '#6c5ce7', fontWeight: 'bold' }),
// //                                             '&:hover': { bgcolor: isSelected ? '#6c5ce7' : '#e2e8f0' },
// //                                         }}
// //                                     >
// //                                         {parseInt(item.n, 10)}
// //                                     </Box>
// //                                 );
// //                             })}
// //                         </Box>
// //                     </Box>
// //                 </DialogContent>

// //                 <DialogActions sx={{ justifyContent: 'space-between', px: 0, pb: 0, pt: 2 }}>
// //                     <IconButton size="small" sx={{ color: '#64748b' }}>
// //                         <KeyboardIcon />
// //                     </IconButton>
// //                     <Box>
// //                         <Button
// //                             onClick={() => setOpenPicker(false)}
// //                             sx={{ textTransform: 'none', fontWeight: 600, color: '#64748b', mr: 1 }}
// //                         >
// //                             Cancel
// //                         </Button>
// //                         <Button
// //                             onClick={handleClockSave}
// //                             sx={{ textTransform: 'none', fontWeight: 700, color: '#6c5ce7' }}
// //                         >
// //                             OK
// //                         </Button>
// //                     </Box>
// //                 </DialogActions>
// //             </Dialog>
// //         </Box>
// //     );
// // }






// import React, { useState, useEffect, useMemo } from 'react';
// import { useSelector } from 'react-redux';
// import toast from 'react-hot-toast';
// import configService from '../services/config';
// import {
//     Box,
//     Stack,
//     Paper,
//     Typography,
//     Button,
//     IconButton,
//     Chip,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     TablePagination,
//     Grid,
//     FormControl,
//     InputLabel,
//     Select,
//     MenuItem,
//     TextField,
//     InputAdornment,
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     ToggleButton,
//     ToggleButtonGroup,
//     CircularProgress,
//     useMediaQuery,
//     Card,
//     CardContent,
// } from '@mui/material';
// import { useTheme } from '@mui/material/styles';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import KeyboardIcon from '@mui/icons-material/Keyboard';
// import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
// import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
// import AddIcon from '@mui/icons-material/Add';
// import InboxIcon from '@mui/icons-material/Inbox';

// const STATUS_CHIP = {
//     Pending: { color: '#EA580C', bg: '#FFF7ED', border: '#FED7AA' },
//     Approved: { color: '#16A34A', bg: '#F0FDF4', border: '#BBF7D0' },
//     Rejected: { color: '#DC2626', bg: '#FEF2F2', border: '#FCA5A5' },
// };

// const ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50];

// const getTodayString = () => {
//     const today = new Date();
//     const yyyy = today.getFullYear();
//     const mm = String(today.getMonth() + 1).padStart(2, '0');
//     const dd = String(today.getDate()).padStart(2, '0');
//     return `${yyyy}-${mm}-${dd}`;
// };

// const getNextWeekString = () => {
//     const futureDate = new Date();
//     futureDate.setDate(futureDate.getDate() + 6);
//     const yyyy = futureDate.getFullYear();
//     const mm = String(futureDate.getMonth() + 1).padStart(2, '0');
//     const dd = String(futureDate.getDate()).padStart(2, '0');
//     return `${yyyy}-${mm}-${dd}`;
// };

// const convertTo24Hour = (timeStr) => {
//     if (!timeStr || timeStr === '—') return '00:00:00';
//     const [time, modifier] = timeStr.split(' ');
//     let [hours, minutes] = time.split(':');

//     if (hours === '12') {
//         hours = '00';
//     }
//     if (modifier === 'PM') {
//         hours = parseInt(hours, 10) + 12;
//     }

//     return `${String(hours).padStart(2, '0')}:${minutes}:00`;
// };

// export default function AttendanceRegularizationList() {
//     const theme = useTheme();

//     // Use breakpoints for switching between table and cards
//     const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md')); // < 900px
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // < 600px

//     // Exact breakpoints from reference CSS for responsive styling
//     const isExtraLarge = useMediaQuery('(min-width:1600px)');
//     const isLaptop = useMediaQuery('(max-width:1200px)');
//     const isTabletLarge = useMediaQuery('(max-width:992px)');
//     const isTablet = useMediaQuery('(max-width:768px)');
//     const isSmallMobile = useMediaQuery('(max-width:420px)');
//     const isLandscapeMobile = useMediaQuery('(max-height:500px) and (orientation:landscape)');

//     const { company_id, userId } = useSelector((state) => state.globalVariables);
//     const [regularizations, setRegularizations] = useState([]);
//     const [loading, setLoading] = useState(true);

//     const [page, setPage] = useState(0);
//     const [rowsPerPage, setRowsPerPage] = useState(10);

//     const [openModal, setOpenModal] = useState(false);
//     const [category, setCategory] = useState('');
//     const [timeType, setTimeType] = useState('');
//     const [selectedDate, setSelectedDate] = useState(getTodayString());
//     const [beginningTime, setBeginningTime] = useState('12:00 AM');
//     const [endTime, setEndTime] = useState('12:00 AM');

//     const [openPicker, setOpenPicker] = useState(false);
//     const [activeField, setActiveField] = useState('beginning');
//     const [pickerView, setPickerView] = useState('hours');
//     const [selectedHour, setSelectedHour] = useState('12');
//     const [selectedMinute, setSelectedMinute] = useState('00');
//     const [ampm, setAmpm] = useState('AM');

//     const fetchData = async () => {
//         setLoading(true);
//         try {
//             const [regRes] = await Promise.all([
//                 configService.getRegularizationList({ company_id, employee_id: userId }),
//             ]);

//             if (regRes?.status) {
//                 setRegularizations(regRes.data || []);
//             } else {
//                 toast.error(regRes?.message || 'No regularization data found');
//             }
//         } catch (error) {
//             console.error('Fetch error:', error);
//             toast.error('Failed to load data. Check network or backend.');
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchData();
//     }, [company_id, userId]);

//     useEffect(() => {
//         setPage(0);
//     }, [rowsPerPage, regularizations.length]);

//     const handleSave = async () => {
//         if (!category || !timeType || !selectedDate) {
//             toast.error('Please fill all the required fields (Category, Time Type, and Date).');
//             return;
//         }

//         const formattedBeginning = convertTo24Hour(beginningTime);
//         const formattedEnd = convertTo24Hour(endTime);

//         const formData = {
//             company_id,
//             employee_id: userId,
//             customer_id: userId,
//             category,
//             time_type: timeType,
//             entry_date: selectedDate,
//             beginning: formattedBeginning,
//             end_time: formattedEnd,
//             remarks: timeType,
//         };

//         try {
//             setLoading(true);
//             const res = await configService.attendanceregularization(formData);

//             if (res?.status === true || res?.data?.status === true || res?.status === 201) {
//                 toast.success('Attendance Regularization saved successfully!');
//                 handleCloseModal();
//                 await fetchData();
//             } else {
//                 toast.error(res?.data?.message || res?.message || 'Failed to save.');
//             }
//         } catch (error) {
//             console.error('Error saving attendance regularization:', error);
//             toast.error(`Error: ${error?.response?.data?.message || error?.message || 'Server Error'}`);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleCloseModal = () => {
//         setOpenModal(false);
//         setCategory('');
//         setTimeType('');
//         setBeginningTime('12:00 AM');
//         setEndTime('12:00 AM');
//         setSelectedDate(getTodayString());
//     };

//     const handleOpenPicker = (field, currentTime) => {
//         setActiveField(field);
//         try {
//             const [time, period] = currentTime.split(' ');
//             const [hr, min] = time.split(':');
//             setSelectedHour(hr || '12');
//             setSelectedMinute(min || '00');
//             setAmpm(period || 'AM');
//         } catch (e) {
//             setSelectedHour('12');
//             setSelectedMinute('00');
//             setAmpm('AM');
//         }
//         setPickerView('hours');
//         setOpenPicker(true);
//     };

//     const handleClockSave = () => {
//         const formattedTime = `${selectedHour}:${selectedMinute} ${ampm}`;
//         if (activeField === 'beginning') {
//             setBeginningTime(formattedTime);
//         } else {
//             setEndTime(formattedTime);
//         }
//         setOpenPicker(false);
//     };

//     const hoursData = [
//         { n: '12', deg: 0 }, { n: '01', deg: 30 }, { n: '02', deg: 60 },
//         { n: '03', deg: 90 }, { n: '04', deg: 120 }, { n: '05', deg: 150 },
//         { n: '06', deg: 180 }, { n: '07', deg: 210 }, { n: '08', deg: 240 },
//         { n: '09', deg: 270 }, { n: '10', deg: 300 }, { n: '11', deg: 330 },
//     ];

//     const minutesData = [
//         { n: '00', deg: 0 }, { n: '05', deg: 30 }, { n: '10', deg: 60 },
//         { n: '15', deg: 90 }, { n: '20', deg: 120 }, { n: '25', deg: 150 },
//         { n: '30', deg: 180 }, { n: '35', deg: 210 }, { n: '40', deg: 240 },
//         { n: '45', deg: 270 }, { n: '50', deg: 300 }, { n: '55', deg: 330 },
//     ];

//     const currentData = pickerView === 'hours' ? hoursData : minutesData;
//     const currentSelection = pickerView === 'hours' ? selectedHour : selectedMinute;
//     const currentRotation = currentData.find((d) => d.n === currentSelection)?.deg || 0;

//     const fmtDate = (d) =>
//         d ? new Date(d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : '—';

//     const totalRows = regularizations.length;

//     const paginatedRows = useMemo(() => {
//         const start = page * rowsPerPage;
//         return regularizations.slice(start, start + rowsPerPage);
//     }, [regularizations, page, rowsPerPage]);

//     const handleChangePage = (_e, newPage) => setPage(newPage);
//     const handleChangeRowsPerPage = (e) => {
//         setRowsPerPage(parseInt(e.target.value, 10));
//         setPage(0);
//     };

//     // --- Dynamic responsive styles (matching reference CSS) ---
//     const getResponsiveValues = () => {
//         let rootPadding = '24px';
//         let paperBorderRadius = '16px';
//         let titleFontSize = '22px';
//         let cellPadding = '12px 14px';
//         let cellFontSize = '13.5px';
//         let chipFontSize = '12px';
//         let chipPadding = '4px 12px';
//         let chipBorderRadius = '6px';
//         let headerDirection = 'row';
//         let buttonFullWidth = false;
//         let modalFullScreen = false;
//         let modalBorderRadius = '16px';
//         let modalBodyPadding = '28px';
//         let rootMaxWidth = 'none';
//         let rootMargin = '0';

//         if (isExtraLarge) {
//             rootMaxWidth = '1400px';
//             rootMargin = '0 auto';
//             cellPadding = '16px 20px';
//         }

//         if (isTabletLarge) {
//             headerDirection = 'column';
//         }

//         if (isTablet) {
//             rootPadding = '16px';
//             paperBorderRadius = '12px';
//             cellPadding = '10px';
//             cellFontSize = '0.8rem';
//             chipFontSize = '0.75rem';
//             chipPadding = '4px 10px';
//             modalFullScreen = true;
//             modalBorderRadius = '0';
//             modalBodyPadding = '20px';
//         }

//         if (isMobile) {
//             rootPadding = '14px';
//             cellPadding = '8px 10px';
//             cellFontSize = '0.8rem';
//             chipFontSize = '0.65rem';
//             chipPadding = '3px 8px';
//             chipBorderRadius = '4px';
//             titleFontSize = '1rem';
//             modalBodyPadding = '14px';
//             buttonFullWidth = true;
//         }

//         if (isSmallMobile) {
//             rootPadding = '10px';
//             cellPadding = '6px 8px';
//             cellFontSize = '0.75rem';
//             chipFontSize = '0.6rem';
//             chipPadding = '2px 6px';
//             titleFontSize = '0.95rem';
//             modalBodyPadding = '12px';
//         }

//         if (isLandscapeMobile) {
//             rootPadding = '8px';
//             headerDirection = 'row';
//             cellPadding = '6px 8px';
//             cellFontSize = '0.7rem';
//         }

//         return {
//             rootPadding,
//             paperBorderRadius,
//             titleFontSize,
//             cellPadding,
//             cellFontSize,
//             chipFontSize,
//             chipPadding,
//             chipBorderRadius,
//             headerDirection,
//             buttonFullWidth,
//             modalFullScreen,
//             modalBorderRadius,
//             modalBodyPadding,
//             rootMaxWidth,
//             rootMargin,
//         };
//     };

//     const responsive = getResponsiveValues();

//     const clockSize = isMobile ? 190 : 220;
//     const clockRadius = isMobile ? 66 : 80;
//     const clockCenter = clockSize / 2;

//     if (loading && regularizations.length === 0) {
//         return (
//             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//                 <Stack spacing={2} alignItems="center">
//                     <CircularProgress sx={{ color: '#6c5ce7' }} />
//                     <Typography color="text.secondary">Loading...</Typography>
//                 </Stack>
//             </Box>
//         );
//     }

//     // --- Render Cards for mobile/tablet ---
//     const renderCards = () => (
//         <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, py: 1 }}>
//             {paginatedRows.map((r) => {
//                 const status = r.status || 'Pending';
//                 const sc = STATUS_CHIP[status] || STATUS_CHIP.Pending;
//                 return (
//                     <Card
//                         key={r.id}
//                         sx={{
//                             bgcolor: '#ffffff',
//                             border: '1px solid #e2e8f0',
//                             boxShadow: 'none',
//                             borderRadius: 2,
//                             '&:hover': { bgcolor: '#f8fafc' },
//                         }}
//                     >
//                         <CardContent sx={{ p: 2 }}>
//                             <Stack spacing={1.5}>
//                                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//                                     <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#0f172a' }}>
//                                         {r.category}
//                                     </Typography>
//                                     <Chip
//                                         label={status}
//                                         size="small"
//                                         sx={{
//                                             bgcolor: sc.bg,
//                                             color: sc.color,
//                                             border: `1px solid ${sc.border}`,
//                                             fontWeight: 600,
//                                             fontSize: responsive.chipFontSize,
//                                             padding: responsive.chipPadding,
//                                             height: 'auto',
//                                             borderRadius: responsive.chipBorderRadius,
//                                         }}
//                                     />
//                                 </Box>
//                                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'space-between' }}>
//                                     <Typography variant="body2" sx={{ color: '#64748b' }}>
//                                         <span style={{ fontWeight: 600, color: '#334155' }}>Time Type:</span> {r.time_type}
//                                     </Typography>
//                                     <Typography variant="body2" sx={{ color: '#64748b' }}>
//                                         <span style={{ fontWeight: 600, color: '#334155' }}>Date:</span> {fmtDate(r.entry_date)}
//                                     </Typography>
//                                 </Box>
//                                 <Typography variant="body2" sx={{ color: '#64748b' }}>
//                                     <span style={{ fontWeight: 600, color: '#334155' }}>Remarks:</span> {r.remarks || '—'}
//                                 </Typography>
//                             </Stack>
//                         </CardContent>
//                     </Card>
//                 );
//             })}
//         </Box>
//     );

//     // --- Render Table for larger screens ---
//     const renderTable = () => (
//         <TableContainer sx={{ flex: 1, overflowX: 'auto', overflowY: 'auto', maxWidth: '100%', width: '100%' }}>
//             <Table
//                 sx={{
//                     width: '100%',
//                     tableLayout: 'fixed',
//                     borderCollapse: 'collapse',
//                 }}
//             >
//                 <TableHead>
//                     <TableRow sx={{ bgcolor: '#f8fafc' }}>
//                         <TableCell
//                             sx={{
//                                 fontWeight: 700,
//                                 fontSize: '11.5px',
//                                 color: '#0f172a',
//                                 textTransform: 'uppercase',
//                                 letterSpacing: '0.05em',
//                                 borderBottom: '1px solid #e2e8f0',
//                                 whiteSpace: 'nowrap',
//                                 padding: responsive.cellPadding,
//                                 width: '20%',
//                             }}
//                         >
//                             Work Type
//                         </TableCell>
//                         <TableCell
//                             sx={{
//                                 fontWeight: 700,
//                                 fontSize: '11.5px',
//                                 color: '#0f172a',
//                                 textTransform: 'uppercase',
//                                 letterSpacing: '0.05em',
//                                 borderBottom: '1px solid #e2e8f0',
//                                 whiteSpace: 'nowrap',
//                                 padding: responsive.cellPadding,
//                                 width: '20%',
//                             }}
//                         >
//                             Time Type
//                         </TableCell>
//                         <TableCell
//                             sx={{
//                                 fontWeight: 700,
//                                 fontSize: '11.5px',
//                                 color: '#0f172a',
//                                 textTransform: 'uppercase',
//                                 letterSpacing: '0.05em',
//                                 borderBottom: '1px solid #e2e8f0',
//                                 whiteSpace: 'nowrap',
//                                 padding: responsive.cellPadding,
//                                 width: '20%',
//                             }}
//                         >
//                             Date
//                         </TableCell>
//                         <TableCell
//                             sx={{
//                                 fontWeight: 700,
//                                 fontSize: '11.5px',
//                                 color: '#0f172a',
//                                 textTransform: 'uppercase',
//                                 letterSpacing: '0.05em',
//                                 borderBottom: '1px solid #e2e8f0',
//                                 whiteSpace: 'nowrap',
//                                 padding: responsive.cellPadding,
//                                 width: '25%',
//                             }}
//                         >
//                             Remarks
//                         </TableCell>
//                         <TableCell
//                             sx={{
//                                 fontWeight: 700,
//                                 fontSize: '11.5px',
//                                 color: '#0f172a',
//                                 textTransform: 'uppercase',
//                                 letterSpacing: '0.05em',
//                                 borderBottom: '1px solid #e2e8f0',
//                                 whiteSpace: 'nowrap',
//                                 padding: responsive.cellPadding,
//                                 width: '15%',
//                             }}
//                         >
//                             Status
//                         </TableCell>
//                     </TableRow>
//                 </TableHead>
//                 <TableBody>
//                     {paginatedRows.map((r) => {
//                         const status = r.status || 'Pending';
//                         const sc = STATUS_CHIP[status] || STATUS_CHIP.Pending;
//                         return (
//                             <TableRow
//                                 key={r.id}
//                                 hover
//                                 sx={{
//                                     '&:last-child td': { border: 0 },
//                                     '&:hover': { bgcolor: '#f8fafc' },
//                                 }}
//                             >
//                                 <TableCell
//                                     sx={{
//                                         color: '#1e293b',
//                                         fontWeight: 500,
//                                         padding: responsive.cellPadding,
//                                         fontSize: responsive.cellFontSize,
//                                         overflow: 'hidden',
//                                         textOverflow: 'ellipsis',
//                                         whiteSpace: 'nowrap',
//                                     }}
//                                 >
//                                     {r.category}
//                                 </TableCell>
//                                 <TableCell
//                                     sx={{
//                                         color: '#1e293b',
//                                         padding: responsive.cellPadding,
//                                         fontSize: responsive.cellFontSize,
//                                         overflow: 'hidden',
//                                         textOverflow: 'ellipsis',
//                                         whiteSpace: 'nowrap',
//                                     }}
//                                 >
//                                     {r.time_type}
//                                 </TableCell>
//                                 <TableCell
//                                     sx={{
//                                         color: '#64748b',
//                                         padding: responsive.cellPadding,
//                                         fontSize: responsive.cellFontSize,
//                                         overflow: 'hidden',
//                                         textOverflow: 'ellipsis',
//                                         whiteSpace: 'nowrap',
//                                     }}
//                                 >
//                                     {fmtDate(r.entry_date)}
//                                 </TableCell>
//                                 <TableCell
//                                     sx={{
//                                         color: '#64748b',
//                                         padding: responsive.cellPadding,
//                                         fontSize: responsive.cellFontSize,
//                                         overflow: 'hidden',
//                                         textOverflow: 'ellipsis',
//                                         whiteSpace: 'nowrap',
//                                     }}
//                                 >
//                                     {r.remarks}
//                                 </TableCell>
//                                 <TableCell sx={{ padding: responsive.cellPadding }}>
//                                     <Chip
//                                         label={status}
//                                         size="small"
//                                         sx={{
//                                             bgcolor: sc.bg,
//                                             color: sc.color,
//                                             border: `1px solid ${sc.border}`,
//                                             fontWeight: 600,
//                                             fontSize: responsive.chipFontSize,
//                                             padding: responsive.chipPadding,
//                                             height: 'auto',
//                                             borderRadius: responsive.chipBorderRadius,
//                                         }}
//                                     />
//                                 </TableCell>
//                             </TableRow>
//                         );
//                     })}
//                 </TableBody>
//             </Table>
//         </TableContainer>
//     );

//     return (
//         <Box
//             sx={{
//                 height: '100dvh',
//                 width: '100%',
//                 maxWidth: '100%',
//                 overflow: 'hidden',
//                 bgcolor: '#f8fafc',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 boxSizing: 'border-box',
//                 p: responsive.rootPadding,
//                 ...(responsive.rootMaxWidth !== 'none' && {
//                     maxWidth: responsive.rootMaxWidth,
//                     margin: responsive.rootMargin,
//                 }),
//             }}
//         >
//             {/* --- HEADER --- */}
//             <Stack
//                 direction={{ xs: 'column', sm: responsive.headerDirection === 'row' ? 'row' : 'column' }}
//                 justifyContent="space-between"
//                 alignItems={{ xs: 'stretch', sm: 'center' }}
//                 spacing={2}
//                 sx={{ flexShrink: 0, mb: 3 }}
//             >
//                 <Typography
//                     variant="h5"
//                     sx={{
//                         fontWeight: 600,
//                         color: '#1e293b',
//                         fontSize: responsive.titleFontSize,
//                     }}
//                 >
//                     Attendance Regularization
//                 </Typography>
//                 <Button
//                     variant="contained"
//                     startIcon={<AddIcon />}
//                     onClick={() => setOpenModal(true)}
//                     fullWidth={responsive.buttonFullWidth || isTabletLarge}
//                     sx={{
//                         bgcolor: '#6c5ce7',
//                         color: '#fff',
//                         textTransform: 'none',
//                         fontWeight: 500,
//                         borderRadius: 2,
//                         px: 3,
//                         py: 1,
//                         boxShadow: '0 4px 6px -1px rgba(108, 92, 231, 0.2)',
//                         '&:hover': { bgcolor: '#5b4bc4' },
//                     }}
//                 >
//                     Apply Regularization
//                 </Button>
//             </Stack>

//             {/* --- DATA TABLE / CARDS --- */}
//             <Paper
//                 elevation={0}
//                 sx={{
//                     borderRadius: responsive.paperBorderRadius,
//                     border: '1px solid #e2e8f0',
//                     overflow: 'hidden',
//                     flex: 1,
//                     display: 'flex',
//                     flexDirection: 'column',
//                     minHeight: 0,
//                     maxWidth: '100%',
//                 }}
//             >
//                 {totalRows === 0 ? (
//                     <Stack alignItems="center" spacing={1.5} sx={{ py: 8, color: '#64748b' }}>
//                         <InboxIcon sx={{ fontSize: 40, color: '#cbd5e1' }} />
//                         <Typography>No regularization requests found.</Typography>
//                     </Stack>
//                 ) : (
//                     <>
//                         {isMobileOrTablet ? renderCards() : renderTable()}

//                         <TablePagination
//                             component="div"
//                             count={totalRows}
//                             page={page}
//                             onPageChange={handleChangePage}
//                             rowsPerPage={rowsPerPage}
//                             onRowsPerPageChange={handleChangeRowsPerPage}
//                             rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
//                             labelRowsPerPage={isTablet ? 'Rows:' : 'Rows per page:'}
//                             ActionsComponent={({ count, page: p, rowsPerPage: rpp, onPageChange }) => (
//                                 <Stack direction="row" spacing={0.5} sx={{ ml: 1 }}>
//                                     <IconButton
//                                         size="small"
//                                         onClick={(e) => onPageChange(e, p - 1)}
//                                         disabled={p === 0}
//                                     >
//                                         <KeyboardArrowLeftIcon />
//                                     </IconButton>
//                                     <IconButton
//                                         size="small"
//                                         onClick={(e) => onPageChange(e, p + 1)}
//                                         disabled={p >= Math.ceil(count / rpp) - 1}
//                                     >
//                                         <KeyboardArrowRightIcon />
//                                     </IconButton>
//                                 </Stack>
//                             )}
//                             sx={{
//                                 borderTop: '1px solid #e2e8f0',
//                                 flexShrink: 0,
//                                 '& .MuiTablePagination-toolbar': {
//                                     justifyContent: 'flex-end',
//                                     flexWrap: 'wrap',
//                                     px: isTablet ? 1 : 2,
//                                 },
//                                 '& .MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
//                                     fontSize: isTablet ? '0.8rem' : '14px',
//                                     color: '#64748b',
//                                 },
//                                 '& .MuiTablePagination-select': {
//                                     fontSize: isTablet ? '0.8rem' : '14px',
//                                 },
//                             }}
//                         />
//                     </>
//                 )}
//             </Paper>

//             {/* ── New Regularization Request Dialog ── */}
//             <Dialog
//                 open={openModal}
//                 onClose={handleCloseModal}
//                 fullScreen={responsive.modalFullScreen}
//                 fullWidth
//                 maxWidth="xs"
//                 PaperProps={{
//                     sx: {
//                         borderRadius: responsive.modalBorderRadius,
//                         border: '1px solid #e2e8f0',
//                     },
//                 }}
//             >
//                 <DialogTitle sx={{ fontWeight: 600, color: '#1e293b', pb: 1 }}>
//                     New Regularization Request
//                 </DialogTitle>
//                 <DialogContent
//                     dividers
//                     sx={{
//                         borderColor: '#e2e8f0',
//                         p: responsive.modalBodyPadding,
//                         // Ensure proper spacing on all devices
//                         '& .MuiFormControl-root': {
//                             width: '100%',
//                             marginBottom: isMobile ? '12px' : '16px',
//                         },
//                         '& .MuiFormControl-root:last-child': {
//                             marginBottom: 0,
//                         },
//                     }}
//                 >
//                     {/* Category */}
//                     <FormControl fullWidth size="small">
//                         <InputLabel id="cat-label">Category</InputLabel>
//                         <Select
//                             labelId="cat-label"
//                             value={category}
//                             label="Category"
//                             onChange={(e) => setCategory(e.target.value)}
//                         >
//                             <MenuItem value="Working Times">Working Times</MenuItem>
//                             <MenuItem value="Break">Break</MenuItem>
//                             <MenuItem value="Overtime">Overtime</MenuItem>
//                         </Select>
//                     </FormControl>

//                     {/* Time Type */}
//                     <FormControl fullWidth size="small">
//                         <InputLabel id="type-label">Time Type</InputLabel>
//                         <Select
//                             labelId="type-label"
//                             value={timeType}
//                             label="Time Type"
//                             onChange={(e) => setTimeType(e.target.value)}
//                         >
//                             <MenuItem value="Attendance Regularization">Attendance Regularization</MenuItem>
//                             <MenuItem value="On Duty">On Duty</MenuItem>
//                         </Select>
//                     </FormControl>

//                     {/* Date */}
//                     <TextField
//                         label="Date"
//                         type="date"
//                         value={selectedDate}
//                         onChange={(e) => setSelectedDate(e.target.value)}
//                         fullWidth
//                         size="small"
//                         inputProps={{ min: getTodayString(), max: getNextWeekString() }}
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                             endAdornment: (
//                                 <InputAdornment position="end">
//                                     <CalendarTodayIcon sx={{ color: '#6c5ce7', fontSize: '1.2rem' }} />
//                                 </InputAdornment>
//                             ),
//                         }}
//                     />

//                     {/* Beginning */}
//                     <TextField
//                         label="Beginning"
//                         value={beginningTime}
//                         onClick={() => handleOpenPicker('beginning', beginningTime)}
//                         fullWidth
//                         size="small"
//                         InputProps={{
//                             readOnly: true,
//                             endAdornment: (
//                                 <InputAdornment position="end">
//                                     <AccessTimeIcon sx={{ color: '#6c5ce7', cursor: 'pointer' }} />
//                                 </InputAdornment>
//                             ),
//                         }}
//                         sx={{ cursor: 'pointer', '& input': { cursor: 'pointer' } }}
//                     />

//                     {/* End */}
//                     <TextField
//                         label="End"
//                         value={endTime}
//                         onClick={() => handleOpenPicker('end', endTime)}
//                         fullWidth
//                         size="small"
//                         InputProps={{
//                             readOnly: true,
//                             endAdornment: (
//                                 <InputAdornment position="end">
//                                     <AccessTimeIcon sx={{ color: '#6c5ce7', cursor: 'pointer' }} />
//                                 </InputAdornment>
//                             ),
//                         }}
//                         sx={{ cursor: 'pointer', '& input': { cursor: 'pointer' } }}
//                     />

//                     {/* Created By */}
//                     <TextField
//                         label="Created By"
//                         value={userId || 'User'}
//                         fullWidth
//                         size="small"
//                         InputProps={{
//                             readOnly: true,
//                             startAdornment: (
//                                 <InputAdornment position="start">
//                                     <AccountCircleIcon sx={{ color: '#94a3b8', mr: 0.5 }} />
//                                 </InputAdornment>
//                             ),
//                         }}
//                         sx={{ '& .MuiOutlinedInput-root': { bgcolor: '#f8fafc' } }}
//                     />
//                 </DialogContent>
//                 <DialogActions sx={{ px: 3, py: 2 }}>
//                     <Button
//                         onClick={handleCloseModal}
//                         sx={{ color: '#64748b', textTransform: 'none', '&:hover': { bgcolor: '#f1f5f9' } }}
//                     >
//                         Cancel
//                     </Button>
//                     <Button
//                         variant="contained"
//                         onClick={handleSave}
//                         disabled={loading}
//                         sx={{ bgcolor: '#6c5ce7', color: '#fff', px: 3, textTransform: 'none', '&:hover': { bgcolor: '#5b4bc4' } }}
//                     >
//                         {loading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Save'}
//                     </Button>
//                 </DialogActions>
//             </Dialog>

//             {/* ── Radial Clock Picker Dialog ── */}
//             <Dialog
//                 open={openPicker}
//                 onClose={() => setOpenPicker(false)}
//                 fullWidth
//                 maxWidth="xs"
//                 PaperProps={{
//                     sx: {
//                         borderRadius: 4,
//                         p: isMobile ? 2 : 3,
//                         border: '1px solid #e2e8f0',
//                     },
//                 }}
//             >
//                 <DialogContent sx={{ p: 0, overflow: 'visible' }}>
//                     <Typography variant="body2" sx={{ color: '#64748b', mb: 2, fontWeight: 500 }}>
//                         Select time
//                     </Typography>

//                     <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} sx={{ mb: 3, flexWrap: 'wrap' }}>
//                         <Box
//                             onClick={() => setPickerView('hours')}
//                             sx={{
//                                 bgcolor: pickerView === 'hours' ? 'rgba(108, 92, 231, 0.1)' : '#f8fafc',
//                                 px: 2.5, py: 1.5, borderRadius: 2, cursor: 'pointer',
//                                 border: pickerView === 'hours' ? '1px solid #6c5ce7' : '1px solid #cbd5e1',
//                             }}
//                         >
//                             <Typography variant="h5" sx={{ color: pickerView === 'hours' ? '#6c5ce7' : '#1e293b', fontWeight: 500 }}>
//                                 {selectedHour}
//                             </Typography>
//                         </Box>

//                         <Typography variant="h5" sx={{ color: '#64748b' }}>:</Typography>

//                         <Box
//                             onClick={() => setPickerView('minutes')}
//                             sx={{
//                                 bgcolor: pickerView === 'minutes' ? 'rgba(108, 92, 231, 0.1)' : '#f8fafc',
//                                 px: 2.5, py: 1.5, borderRadius: 2, cursor: 'pointer',
//                                 border: pickerView === 'minutes' ? '1px solid #6c5ce7' : '1px solid #cbd5e1',
//                             }}
//                         >
//                             <Typography variant="h5" sx={{ color: pickerView === 'minutes' ? '#6c5ce7' : '#1e293b', fontWeight: 500 }}>
//                                 {selectedMinute}
//                             </Typography>
//                         </Box>

//                         <ToggleButtonGroup
//                             orientation="vertical"
//                             value={ampm}
//                             exclusive
//                             onChange={(e, val) => val && setAmpm(val)}
//                             sx={{
//                                 border: '1px solid #cbd5e1',
//                                 borderRadius: 2,
//                                 ml: 1,
//                                 bgcolor: '#f8fafc',
//                                 '& .MuiToggleButton-root': {
//                                     px: 1.5, py: 0.8, fontSize: '0.85rem', border: 'none', color: '#64748b',
//                                     '&.Mui-selected': { bgcolor: 'rgba(108, 92, 231, 0.1)', color: '#6c5ce7', fontWeight: 'bold' },
//                                 },
//                             }}
//                         >
//                             <ToggleButton value="AM">AM</ToggleButton>
//                             <ToggleButton value="PM" sx={{ borderTop: '1px solid #cbd5e1 !important' }}>PM</ToggleButton>
//                         </ToggleButtonGroup>
//                     </Stack>

//                     <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
//                         <Box
//                             sx={{
//                                 width: clockSize,
//                                 height: clockSize,
//                                 borderRadius: '50%',
//                                 bgcolor: '#f8fafc',
//                                 position: 'relative',
//                                 border: '1px solid #cbd5e1',
//                             }}
//                         >
//                             <Box
//                                 sx={{
//                                     width: 6,
//                                     height: 6,
//                                     bgcolor: '#6c5ce7',
//                                     borderRadius: '50%',
//                                     position: 'absolute',
//                                     top: '50%',
//                                     left: '50%',
//                                     transform: 'translate(-50%, -50%)',
//                                     zIndex: 3,
//                                 }}
//                             />
//                             <Box
//                                 sx={{
//                                     position: 'absolute',
//                                     width: 2,
//                                     height: clockRadius - 4,
//                                     bgcolor: '#6c5ce7',
//                                     bottom: '50%',
//                                     left: '50%',
//                                     transformOrigin: 'bottom center',
//                                     transform: `translateX(-50%) rotate(${currentRotation}deg)`,
//                                     zIndex: 1,
//                                 }}
//                             />

//                             {currentData.map((item) => {
//                                 const angleRad = (item.deg - 90) * (Math.PI / 180);
//                                 const x = clockCenter + clockRadius * Math.cos(angleRad);
//                                 const y = clockCenter + clockRadius * Math.sin(angleRad);
//                                 const isSelected = currentSelection === item.n;

//                                 return (
//                                     <Box
//                                         key={item.n}
//                                         onClick={() => {
//                                             if (pickerView === 'hours') {
//                                                 setSelectedHour(item.n);
//                                                 setPickerView('minutes');
//                                             } else {
//                                                 setSelectedMinute(item.n);
//                                             }
//                                         }}
//                                         sx={{
//                                             position: 'absolute',
//                                             left: x,
//                                             top: y,
//                                             transform: 'translate(-50%, -50%)',
//                                             fontSize: '0.85rem',
//                                             color: isSelected ? '#fff' : '#475569',
//                                             cursor: 'pointer',
//                                             zIndex: 2,
//                                             width: 32,
//                                             height: 32,
//                                             display: 'flex',
//                                             alignItems: 'center',
//                                             justifyContent: 'center',
//                                             borderRadius: '50%',
//                                             transition: '0.1s',
//                                             ...(isSelected && { bgcolor: '#6c5ce7', fontWeight: 'bold' }),
//                                             '&:hover': { bgcolor: isSelected ? '#6c5ce7' : '#e2e8f0' },
//                                         }}
//                                     >
//                                         {parseInt(item.n, 10)}
//                                     </Box>
//                                 );
//                             })}
//                         </Box>
//                     </Box>
//                 </DialogContent>

//                 <DialogActions sx={{ justifyContent: 'space-between', px: 0, pb: 0, pt: 2 }}>
//                     <IconButton size="small" sx={{ color: '#64748b' }}>
//                         <KeyboardIcon />
//                     </IconButton>
//                     <Box>
//                         <Button
//                             onClick={() => setOpenPicker(false)}
//                             sx={{ textTransform: 'none', fontWeight: 600, color: '#64748b', mr: 1 }}
//                         >
//                             Cancel
//                         </Button>
//                         <Button
//                             onClick={handleClockSave}
//                             sx={{ textTransform: 'none', fontWeight: 700, color: '#6c5ce7' }}
//                         >
//                             OK
//                         </Button>
//                     </Box>
//                 </DialogActions>
//             </Dialog>
//         </Box>
//     );
// }



import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import configService from '../services/config';
import {
    Box,
    Stack,
    Paper,
    Typography,
    Button,
    IconButton,
    Chip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    InputAdornment,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    ToggleButton,
    ToggleButtonGroup,
    CircularProgress,
    useMediaQuery,
    Card,
    CardContent,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import AddIcon from '@mui/icons-material/Add';
import InboxIcon from '@mui/icons-material/Inbox';

const STATUS_CHIP = {
    Pending: { color: '#EA580C', bg: '#FFF7ED', border: '#FED7AA' },
    Approved: { color: '#16A34A', bg: '#F0FDF4', border: '#BBF7D0' },
    Rejected: { color: '#DC2626', bg: '#FEF2F2', border: '#FCA5A5' },
};

const ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50];

const getTodayString = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};

const getNextWeekString = () => {
    const futureDate = new Date();
    futureDate.setDate(futureDate.getDate() + 6);
    const yyyy = futureDate.getFullYear();
    const mm = String(futureDate.getMonth() + 1).padStart(2, '0');
    const dd = String(futureDate.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};

const convertTo24Hour = (timeStr) => {
    if (!timeStr || timeStr === '—') return '00:00:00';
    const [time, modifier] = timeStr.split(' ');
    let [hours, minutes] = time.split(':');

    if (hours === '12') {
        hours = '00';
    }
    if (modifier === 'PM') {
        hours = parseInt(hours, 10) + 12;
    }

    return `${String(hours).padStart(2, '0')}:${minutes}:00`;
};

export default function AttendanceRegularizationList() {
    const theme = useTheme();

    const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const isExtraLarge = useMediaQuery('(min-width:1600px)');
    const isTabletLarge = useMediaQuery('(max-width:992px)');
    const isTablet = useMediaQuery('(max-width:768px)');
    const isSmallMobile = useMediaQuery('(max-width:420px)');
    const isLandscapeMobile = useMediaQuery('(max-height:500px) and (orientation:landscape)');

    const { company_id, userId } = useSelector((state) => state.globalVariables);
    const [regularizations, setRegularizations] = useState([]);
    const [loading, setLoading] = useState(true);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const [openModal, setOpenModal] = useState(false);
    const [category, setCategory] = useState('');
    const [timeType, setTimeType] = useState('');
    const [selectedDate, setSelectedDate] = useState(getTodayString());
    const [beginningTime, setBeginningTime] = useState('12:00 AM');
    const [endTime, setEndTime] = useState('12:00 AM');

    const [openPicker, setOpenPicker] = useState(false);
    const [activeField, setActiveField] = useState('beginning');
    const [pickerView, setPickerView] = useState('hours');
    const [selectedHour, setSelectedHour] = useState('12');
    const [selectedMinute, setSelectedMinute] = useState('00');
    const [ampm, setAmpm] = useState('AM');

    const fetchData = async () => {
        setLoading(true);
        try {
            const [regRes] = await Promise.all([
                configService.getRegularizationList({ company_id, employee_id: userId }),
            ]);

            if (regRes?.status) {
                setRegularizations(regRes.data || []);
            } else {
                toast.error(regRes?.message || 'No regularization data found');
            }
        } catch (error) {
            console.error('Fetch error:', error);
            toast.error('Failed to load data. Check network or backend.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [company_id, userId]);

    useEffect(() => {
        setPage(0);
    }, [rowsPerPage, regularizations.length]);

    const handleSave = async () => {
        if (!category || !timeType || !selectedDate) {
            toast.error('Please fill all the required fields (Category, Time Type, and Date).');
            return;
        }

        const formattedBeginning = convertTo24Hour(beginningTime);
        const formattedEnd = convertTo24Hour(endTime);

        const formData = {
            company_id,
            employee_id: userId,
            customer_id: userId,
            category,
            time_type: timeType,
            entry_date: selectedDate,
            beginning: formattedBeginning,
            end_time: formattedEnd,
            remarks: timeType,
        };

        try {
            setLoading(true);
            const res = await configService.attendanceregularization(formData);

            if (res?.status === true || res?.data?.status === true || res?.status === 201) {
                toast.success('Attendance Regularization saved successfully!');
                handleCloseModal();
                await fetchData();
            } else {
                toast.error(res?.data?.message || res?.message || 'Failed to save.');
            }
        } catch (error) {
            console.error('Error saving attendance regularization:', error);
            toast.error(`Error: ${error?.response?.data?.message || error?.message || 'Server Error'}`);
        } finally {
            setLoading(false);
        }
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setCategory('');
        setTimeType('');
        setBeginningTime('12:00 AM');
        setEndTime('12:00 AM');
        setSelectedDate(getTodayString());
    };

    const handleOpenPicker = (field, currentTime) => {
        setActiveField(field);
        try {
            const [time, period] = currentTime.split(' ');
            const [hr, min] = time.split(':');
            setSelectedHour(hr || '12');
            setSelectedMinute(min || '00');
            setAmpm(period || 'AM');
        } catch (e) {
            setSelectedHour('12');
            setSelectedMinute('00');
            setAmpm('AM');
        }
        setPickerView('hours');
        setOpenPicker(true);
    };

    const handleClockSave = () => {
        const formattedTime = `${selectedHour}:${selectedMinute} ${ampm}`;
        if (activeField === 'beginning') {
            setBeginningTime(formattedTime);
        } else {
            setEndTime(formattedTime);
        }
        setOpenPicker(false);
    };

    const hoursData = [
        { n: '12', deg: 0 }, { n: '01', deg: 30 }, { n: '02', deg: 60 },
        { n: '03', deg: 90 }, { n: '04', deg: 120 }, { n: '05', deg: 150 },
        { n: '06', deg: 180 }, { n: '07', deg: 210 }, { n: '08', deg: 240 },
        { n: '09', deg: 270 }, { n: '10', deg: 300 }, { n: '11', deg: 330 },
    ];

    const minutesData = [
        { n: '00', deg: 0 }, { n: '05', deg: 30 }, { n: '10', deg: 60 },
        { n: '15', deg: 90 }, { n: '20', deg: 120 }, { n: '25', deg: 150 },
        { n: '30', deg: 180 }, { n: '35', deg: 210 }, { n: '40', deg: 240 },
        { n: '45', deg: 270 }, { n: '50', deg: 300 }, { n: '55', deg: 330 },
    ];

    const currentData = pickerView === 'hours' ? hoursData : minutesData;
    const currentSelection = pickerView === 'hours' ? selectedHour : selectedMinute;
    const currentRotation = currentData.find((d) => d.n === currentSelection)?.deg || 0;

    const fmtDate = (d) =>
        d ? new Date(d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : '—';

    const totalRows = regularizations.length;

    const paginatedRows = useMemo(() => {
        const start = page * rowsPerPage;
        return regularizations.slice(start, start + rowsPerPage);
    }, [regularizations, page, rowsPerPage]);

    const handleChangePage = (_e, newPage) => setPage(newPage);
    const handleChangeRowsPerPage = (e) => {
        setRowsPerPage(parseInt(e.target.value, 10));
        setPage(0);
    };

    // --- Dynamic responsive styles ---
    const getResponsiveValues = () => {
        let rootPadding = '24px';
        let paperBorderRadius = '16px';
        let titleFontSize = '22px';
        let cellPadding = '12px 14px';
        let cellFontSize = '13.5px';
        let chipFontSize = '12px';
        let chipPadding = '4px 12px';
        let chipBorderRadius = '6px';
        let headerDirection = 'row';
        let buttonFullWidth = false;
        let modalFullScreen = false;
        let modalBorderRadius = '16px';
        let modalBodyPadding = '28px';
        let rootMaxWidth = 'none';
        let rootMargin = '0';

        if (isExtraLarge) {
            rootMaxWidth = '1400px';
            rootMargin = '0 auto';
            cellPadding = '16px 20px';
        }

        if (isTabletLarge) {
            headerDirection = 'column';
        }

        if (isTablet) {
            rootPadding = '16px';
            paperBorderRadius = '12px';
            cellPadding = '10px';
            cellFontSize = '0.8rem';
            chipFontSize = '0.75rem';
            chipPadding = '4px 10px';
            modalFullScreen = true;
            modalBorderRadius = '0';
            modalBodyPadding = '20px';
        }

        if (isMobile) {
            rootPadding = '14px';
            cellPadding = '8px 10px';
            cellFontSize = '0.8rem';
            chipFontSize = '0.65rem';
            chipPadding = '3px 8px';
            chipBorderRadius = '4px';
            titleFontSize = '1rem';
            modalBodyPadding = '14px';
            buttonFullWidth = true;
        }

        if (isSmallMobile) {
            rootPadding = '10px';
            cellPadding = '6px 8px';
            cellFontSize = '0.75rem';
            chipFontSize = '0.6rem';
            chipPadding = '2px 6px';
            titleFontSize = '0.95rem';
            modalBodyPadding = '12px';
        }

        if (isLandscapeMobile) {
            rootPadding = '8px';
            headerDirection = 'row';
            cellPadding = '6px 8px';
            cellFontSize = '0.7rem';
        }

        return {
            rootPadding,
            paperBorderRadius,
            titleFontSize,
            cellPadding,
            cellFontSize,
            chipFontSize,
            chipPadding,
            chipBorderRadius,
            headerDirection,
            buttonFullWidth,
            modalFullScreen,
            modalBorderRadius,
            modalBodyPadding,
            rootMaxWidth,
            rootMargin,
        };
    };

    const responsive = getResponsiveValues();

    const clockSize = isMobile ? 190 : 220;
    const clockRadius = isMobile ? 66 : 80;
    const clockCenter = clockSize / 2;

    if (loading && regularizations.length === 0) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                <Stack spacing={2} alignItems="center">
                    <CircularProgress sx={{ color: '#6c5ce7' }} />
                    <Typography color="text.secondary">Loading...</Typography>
                </Stack>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                minHeight: '100vh',
                width: '100%',
                maxWidth: '100%',
                overflow: 'auto',
                bgcolor: '#f8fafc',
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box',
                p: responsive.rootPadding,
                ...(responsive.rootMaxWidth !== 'none' && {
                    maxWidth: responsive.rootMaxWidth,
                    margin: responsive.rootMargin,
                }),
            }}
        >
            {/* --- HEADER --- */}
            <Stack
                direction={{ xs: 'column', sm: responsive.headerDirection === 'row' ? 'row' : 'column' }}
                justifyContent="space-between"
                alignItems={{ xs: 'stretch', sm: 'center' }}
                spacing={2}
                sx={{ flexShrink: 0, mb: 3 }}
            >
                <Typography
                    variant="h5"
                    sx={{
                        fontWeight: 600,
                        color: '#1e293b',
                        fontSize: responsive.titleFontSize,
                    }}
                >
                    Attendance Regularization
                </Typography>
                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => setOpenModal(true)}
                    fullWidth={responsive.buttonFullWidth || isTabletLarge}
                    sx={{
                        bgcolor: '#6c5ce7',
                        color: '#fff',
                        textTransform: 'none',
                        fontWeight: 500,
                        borderRadius: 2,
                        px: 3,
                        py: 1,
                        boxShadow: '0 4px 6px -1px rgba(108, 92, 231, 0.2)',
                        '&:hover': { bgcolor: '#5b4bc4' },
                    }}
                >
                    Apply Regularization
                </Button>
            </Stack>

            {/* --- DATA TABLE / CARDS --- */}
            <Paper
                elevation={0}
                sx={{
                    borderRadius: responsive.paperBorderRadius,
                    border: '1px solid #e2e8f0',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                }}
            >
                {totalRows === 0 ? (
                    <Stack alignItems="center" spacing={1.5} sx={{ py: 8, color: '#64748b' }}>
                        <InboxIcon sx={{ fontSize: 40, color: '#cbd5e1' }} />
                        <Typography>No regularization requests found.</Typography>
                    </Stack>
                ) : (
                    <>
                        {/* ---- Responsive content: Cards on mobile, Table on larger ---- */}
                        {isMobileOrTablet ? (
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, py: 2, px: 1 }}>
                                {paginatedRows.map((r) => {
                                    const status = r.status || 'Pending';
                                    const sc = STATUS_CHIP[status] || STATUS_CHIP.Pending;
                                    return (
                                        <Card
                                            key={r.id}
                                            sx={{
                                                bgcolor: '#ffffff',
                                                border: '1px solid #e2e8f0',
                                                boxShadow: 'none',
                                                borderRadius: 2,
                                                '&:hover': { bgcolor: '#f8fafc' },
                                            }}
                                        >
                                            <CardContent sx={{ p: 2 }}>
                                                <Stack spacing={1.5}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                                        <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#0f172a' }}>
                                                            {r.category}
                                                        </Typography>
                                                        <Chip
                                                            label={status}
                                                            size="small"
                                                            sx={{
                                                                bgcolor: sc.bg,
                                                                color: sc.color,
                                                                border: `1px solid ${sc.border}`,
                                                                fontWeight: 600,
                                                                fontSize: responsive.chipFontSize,
                                                                padding: responsive.chipPadding,
                                                                height: 'auto',
                                                                borderRadius: responsive.chipBorderRadius,
                                                            }}
                                                        />
                                                    </Box>
                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'space-between' }}>
                                                        <Typography variant="body2" sx={{ color: '#64748b' }}>
                                                            <span style={{ fontWeight: 600, color: '#334155' }}>Time Type:</span> {r.time_type}
                                                        </Typography>
                                                        <Typography variant="body2" sx={{ color: '#64748b' }}>
                                                            <span style={{ fontWeight: 600, color: '#334155' }}>Date:</span> {fmtDate(r.entry_date)}
                                                        </Typography>
                                                    </Box>
                                                    <Typography variant="body2" sx={{ color: '#64748b' }}>
                                                        <span style={{ fontWeight: 600, color: '#334155' }}>Remarks:</span> {r.remarks || '—'}
                                                    </Typography>
                                                </Stack>
                                            </CardContent>
                                        </Card>
                                    );
                                })}
                            </Box>
                        ) : (
                            <TableContainer sx={{ overflowX: 'auto', overflowY: 'auto', maxWidth: '100%', width: '100%' }}>
                                <Table
                                    sx={{
                                        width: '100%',
                                        tableLayout: 'fixed',
                                        borderCollapse: 'collapse',
                                    }}
                                >
                                    <TableHead>
                                        <TableRow sx={{ bgcolor: '#f8fafc' }}>
                                            <TableCell
                                                sx={{
                                                    fontWeight: 700,
                                                    fontSize: '11.5px',
                                                    color: '#0f172a',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.05em',
                                                    borderBottom: '1px solid #e2e8f0',
                                                    whiteSpace: 'nowrap',
                                                    padding: responsive.cellPadding,
                                                    width: '20%',
                                                }}
                                            >
                                                Work Type
                                            </TableCell>
                                            <TableCell
                                                sx={{
                                                    fontWeight: 700,
                                                    fontSize: '11.5px',
                                                    color: '#0f172a',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.05em',
                                                    borderBottom: '1px solid #e2e8f0',
                                                    whiteSpace: 'nowrap',
                                                    padding: responsive.cellPadding,
                                                    width: '20%',
                                                }}
                                            >
                                                Time Type
                                            </TableCell>
                                            <TableCell
                                                sx={{
                                                    fontWeight: 700,
                                                    fontSize: '11.5px',
                                                    color: '#0f172a',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.05em',
                                                    borderBottom: '1px solid #e2e8f0',
                                                    whiteSpace: 'nowrap',
                                                    padding: responsive.cellPadding,
                                                    width: '20%',
                                                }}
                                            >
                                                Date
                                            </TableCell>
                                            <TableCell
                                                sx={{
                                                    fontWeight: 700,
                                                    fontSize: '11.5px',
                                                    color: '#0f172a',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.05em',
                                                    borderBottom: '1px solid #e2e8f0',
                                                    whiteSpace: 'nowrap',
                                                    padding: responsive.cellPadding,
                                                    width: '25%',
                                                }}
                                            >
                                                Remarks
                                            </TableCell>
                                            <TableCell
                                                sx={{
                                                    fontWeight: 700,
                                                    fontSize: '11.5px',
                                                    color: '#0f172a',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.05em',
                                                    borderBottom: '1px solid #e2e8f0',
                                                    whiteSpace: 'nowrap',
                                                    padding: responsive.cellPadding,
                                                    width: '15%',
                                                }}
                                            >
                                                Status
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {paginatedRows.map((r) => {
                                            const status = r.status || 'Pending';
                                            const sc = STATUS_CHIP[status] || STATUS_CHIP.Pending;
                                            return (
                                                <TableRow
                                                    key={r.id}
                                                    hover
                                                    sx={{
                                                        '&:last-child td': { border: 0 },
                                                        '&:hover': { bgcolor: '#f8fafc' },
                                                    }}
                                                >
                                                    <TableCell
                                                        sx={{
                                                            color: '#1e293b',
                                                            fontWeight: 500,
                                                            padding: responsive.cellPadding,
                                                            fontSize: responsive.cellFontSize,
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap',
                                                        }}
                                                    >
                                                        {r.category}
                                                    </TableCell>
                                                    <TableCell
                                                        sx={{
                                                            color: '#1e293b',
                                                            padding: responsive.cellPadding,
                                                            fontSize: responsive.cellFontSize,
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap',
                                                        }}
                                                    >
                                                        {r.time_type}
                                                    </TableCell>
                                                    <TableCell
                                                        sx={{
                                                            color: '#64748b',
                                                            padding: responsive.cellPadding,
                                                            fontSize: responsive.cellFontSize,
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap',
                                                        }}
                                                    >
                                                        {fmtDate(r.entry_date)}
                                                    </TableCell>
                                                    <TableCell
                                                        sx={{
                                                            color: '#64748b',
                                                            padding: responsive.cellPadding,
                                                            fontSize: responsive.cellFontSize,
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap',
                                                        }}
                                                    >
                                                        {r.remarks}
                                                    </TableCell>
                                                    <TableCell sx={{ padding: responsive.cellPadding }}>
                                                        <Chip
                                                            label={status}
                                                            size="small"
                                                            sx={{
                                                                bgcolor: sc.bg,
                                                                color: sc.color,
                                                                border: `1px solid ${sc.border}`,
                                                                fontWeight: 600,
                                                                fontSize: responsive.chipFontSize,
                                                                padding: responsive.chipPadding,
                                                                height: 'auto',
                                                                borderRadius: responsive.chipBorderRadius,
                                                            }}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}

                        <TablePagination
                            component="div"
                            count={totalRows}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
                            labelRowsPerPage={isTablet ? 'Rows:' : 'Rows per page:'}
                            ActionsComponent={({ count, page: p, rowsPerPage: rpp, onPageChange }) => (
                                <Stack direction="row" spacing={0.5} sx={{ ml: 1 }}>
                                    <IconButton
                                        size="small"
                                        onClick={(e) => onPageChange(e, p - 1)}
                                        disabled={p === 0}
                                    >
                                        <KeyboardArrowLeftIcon />
                                    </IconButton>
                                    <IconButton
                                        size="small"
                                        onClick={(e) => onPageChange(e, p + 1)}
                                        disabled={p >= Math.ceil(count / rpp) - 1}
                                    >
                                        <KeyboardArrowRightIcon />
                                    </IconButton>
                                </Stack>
                            )}
                            sx={{
                                borderTop: '1px solid #e2e8f0',
                                flexShrink: 0,
                                '& .MuiTablePagination-toolbar': {
                                    justifyContent: 'flex-end',
                                    flexWrap: 'wrap',
                                    px: isTablet ? 1 : 2,
                                },
                                '& .MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
                                    fontSize: isTablet ? '0.8rem' : '14px',
                                    color: '#64748b',
                                },
                                '& .MuiTablePagination-select': {
                                    fontSize: isTablet ? '0.8rem' : '14px',
                                },
                            }}
                        />
                    </>
                )}
            </Paper>

            {/* ── New Regularization Request Dialog ── */}
            <Dialog
                open={openModal}
                onClose={handleCloseModal}
                fullScreen={responsive.modalFullScreen}
                fullWidth
                maxWidth="xs"
                PaperProps={{
                    sx: {
                        borderRadius: responsive.modalBorderRadius,
                        border: '1px solid #e2e8f0',
                    },
                }}
            >
                <DialogTitle sx={{ fontWeight: 600, color: '#1e293b', pb: 1 }}>
                    New Regularization Request
                </DialogTitle>
                <DialogContent
                    dividers
                    sx={{
                        borderColor: '#e2e8f0',
                        p: responsive.modalBodyPadding,
                        '& .MuiFormControl-root': {
                            width: '100%',
                            marginBottom: isMobile ? '12px' : '16px',
                        },
                        '& .MuiFormControl-root:last-child': {
                            marginBottom: 0,
                        },
                    }}
                >
                    <FormControl fullWidth size="small">
                        <InputLabel id="cat-label">Category</InputLabel>
                        <Select
                            labelId="cat-label"
                            value={category}
                            label="Category"
                            onChange={(e) => setCategory(e.target.value)}
                        >
                            <MenuItem value="Working Times">Working Times</MenuItem>
                            <MenuItem value="Break">Break</MenuItem>
                            <MenuItem value="Overtime">Overtime</MenuItem>
                        </Select>
                    </FormControl>

                    <FormControl fullWidth size="small">
                        <InputLabel id="type-label">Time Type</InputLabel>
                        <Select
                            labelId="type-label"
                            value={timeType}
                            label="Time Type"
                            onChange={(e) => setTimeType(e.target.value)}
                        >
                            <MenuItem value="Attendance Regularization">Attendance Regularization</MenuItem>
                            <MenuItem value="On Duty">On Duty</MenuItem>
                        </Select>
                    </FormControl>

                    <TextField
                        label="Date"
                        type="date"
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        fullWidth
                        size="small"
                        inputProps={{ min: getTodayString(), max: getNextWeekString() }}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <CalendarTodayIcon sx={{ color: '#6c5ce7', fontSize: '1.2rem' }} />
                                </InputAdornment>
                            ),
                        }}
                    />

                    <TextField
                        label="Beginning"
                        value={beginningTime}
                        onClick={() => handleOpenPicker('beginning', beginningTime)}
                        fullWidth
                        size="small"
                        InputProps={{
                            readOnly: true,
                            endAdornment: (
                                <InputAdornment position="end">
                                    <AccessTimeIcon sx={{ color: '#6c5ce7', cursor: 'pointer' }} />
                                </InputAdornment>
                            ),
                        }}
                        sx={{ cursor: 'pointer', '& input': { cursor: 'pointer' } }}
                    />

                    <TextField
                        label="End"
                        value={endTime}
                        onClick={() => handleOpenPicker('end', endTime)}
                        fullWidth
                        size="small"
                        InputProps={{
                            readOnly: true,
                            endAdornment: (
                                <InputAdornment position="end">
                                    <AccessTimeIcon sx={{ color: '#6c5ce7', cursor: 'pointer' }} />
                                </InputAdornment>
                            ),
                        }}
                        sx={{ cursor: 'pointer', '& input': { cursor: 'pointer' } }}
                    />

                    <TextField
                        label="Created By"
                        value={userId || 'User'}
                        fullWidth
                        size="small"
                        InputProps={{
                            readOnly: true,
                            startAdornment: (
                                <InputAdornment position="start">
                                    <AccountCircleIcon sx={{ color: '#94a3b8', mr: 0.5 }} />
                                </InputAdornment>
                            ),
                        }}
                        sx={{ '& .MuiOutlinedInput-root': { bgcolor: '#f8fafc' } }}
                    />
                </DialogContent>
                <DialogActions sx={{ px: 3, py: 2 }}>
                    <Button
                        onClick={handleCloseModal}
                        sx={{ color: '#64748b', textTransform: 'none', '&:hover': { bgcolor: '#f1f5f9' } }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSave}
                        disabled={loading}
                        sx={{ bgcolor: '#6c5ce7', color: '#fff', px: 3, textTransform: 'none', '&:hover': { bgcolor: '#5b4bc4' } }}
                    >
                        {loading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Save'}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* ── Radial Clock Picker Dialog ── */}
            <Dialog
                open={openPicker}
                onClose={() => setOpenPicker(false)}
                fullWidth
                maxWidth="xs"
                PaperProps={{
                    sx: {
                        borderRadius: 4,
                        p: isMobile ? 2 : 3,
                        border: '1px solid #e2e8f0',
                    },
                }}
            >
                <DialogContent sx={{ p: 0, overflow: 'visible' }}>
                    <Typography variant="body2" sx={{ color: '#64748b', mb: 2, fontWeight: 500 }}>
                        Select time
                    </Typography>

                    <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} sx={{ mb: 3, flexWrap: 'wrap' }}>
                        <Box
                            onClick={() => setPickerView('hours')}
                            sx={{
                                bgcolor: pickerView === 'hours' ? 'rgba(108, 92, 231, 0.1)' : '#f8fafc',
                                px: 2.5, py: 1.5, borderRadius: 2, cursor: 'pointer',
                                border: pickerView === 'hours' ? '1px solid #6c5ce7' : '1px solid #cbd5e1',
                            }}
                        >
                            <Typography variant="h5" sx={{ color: pickerView === 'hours' ? '#6c5ce7' : '#1e293b', fontWeight: 500 }}>
                                {selectedHour}
                            </Typography>
                        </Box>

                        <Typography variant="h5" sx={{ color: '#64748b' }}>:</Typography>

                        <Box
                            onClick={() => setPickerView('minutes')}
                            sx={{
                                bgcolor: pickerView === 'minutes' ? 'rgba(108, 92, 231, 0.1)' : '#f8fafc',
                                px: 2.5, py: 1.5, borderRadius: 2, cursor: 'pointer',
                                border: pickerView === 'minutes' ? '1px solid #6c5ce7' : '1px solid #cbd5e1',
                            }}
                        >
                            <Typography variant="h5" sx={{ color: pickerView === 'minutes' ? '#6c5ce7' : '#1e293b', fontWeight: 500 }}>
                                {selectedMinute}
                            </Typography>
                        </Box>

                        <ToggleButtonGroup
                            orientation="vertical"
                            value={ampm}
                            exclusive
                            onChange={(e, val) => val && setAmpm(val)}
                            sx={{
                                border: '1px solid #cbd5e1',
                                borderRadius: 2,
                                ml: 1,
                                bgcolor: '#f8fafc',
                                '& .MuiToggleButton-root': {
                                    px: 1.5, py: 0.8, fontSize: '0.85rem', border: 'none', color: '#64748b',
                                    '&.Mui-selected': { bgcolor: 'rgba(108, 92, 231, 0.1)', color: '#6c5ce7', fontWeight: 'bold' },
                                },
                            }}
                        >
                            <ToggleButton value="AM">AM</ToggleButton>
                            <ToggleButton value="PM" sx={{ borderTop: '1px solid #cbd5e1 !important' }}>PM</ToggleButton>
                        </ToggleButtonGroup>
                    </Stack>

                    <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                        <Box
                            sx={{
                                width: clockSize,
                                height: clockSize,
                                borderRadius: '50%',
                                bgcolor: '#f8fafc',
                                position: 'relative',
                                border: '1px solid #cbd5e1',
                            }}
                        >
                            <Box
                                sx={{
                                    width: 6,
                                    height: 6,
                                    bgcolor: '#6c5ce7',
                                    borderRadius: '50%',
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    zIndex: 3,
                                }}
                            />
                            <Box
                                sx={{
                                    position: 'absolute',
                                    width: 2,
                                    height: clockRadius - 4,
                                    bgcolor: '#6c5ce7',
                                    bottom: '50%',
                                    left: '50%',
                                    transformOrigin: 'bottom center',
                                    transform: `translateX(-50%) rotate(${currentRotation}deg)`,
                                    zIndex: 1,
                                }}
                            />

                            {currentData.map((item) => {
                                const angleRad = (item.deg - 90) * (Math.PI / 180);
                                const x = clockCenter + clockRadius * Math.cos(angleRad);
                                const y = clockCenter + clockRadius * Math.sin(angleRad);
                                const isSelected = currentSelection === item.n;

                                return (
                                    <Box
                                        key={item.n}
                                        onClick={() => {
                                            if (pickerView === 'hours') {
                                                setSelectedHour(item.n);
                                                setPickerView('minutes');
                                            } else {
                                                setSelectedMinute(item.n);
                                            }
                                        }}
                                        sx={{
                                            position: 'absolute',
                                            left: x,
                                            top: y,
                                            transform: 'translate(-50%, -50%)',
                                            fontSize: '0.85rem',
                                            color: isSelected ? '#fff' : '#475569',
                                            cursor: 'pointer',
                                            zIndex: 2,
                                            width: 32,
                                            height: 32,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            borderRadius: '50%',
                                            transition: '0.1s',
                                            ...(isSelected && { bgcolor: '#6c5ce7', fontWeight: 'bold' }),
                                            '&:hover': { bgcolor: isSelected ? '#6c5ce7' : '#e2e8f0' },
                                        }}
                                    >
                                        {parseInt(item.n, 10)}
                                    </Box>
                                );
                            })}
                        </Box>
                    </Box>
                </DialogContent>

                <DialogActions sx={{ justifyContent: 'space-between', px: 0, pb: 0, pt: 2 }}>
                    <IconButton size="small" sx={{ color: '#64748b' }}>
                        <KeyboardIcon />
                    </IconButton>
                    <Box>
                        <Button
                            onClick={() => setOpenPicker(false)}
                            sx={{ textTransform: 'none', fontWeight: 600, color: '#64748b', mr: 1 }}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={handleClockSave}
                            sx={{ textTransform: 'none', fontWeight: 700, color: '#6c5ce7' }}
                        >
                            OK
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>
        </Box>
    );
}